import * as React from "react";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  styled,
  TextField,
  Typography,
  InputAdornment,
  CardContent,
  Card,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  ListItemButton,
  CircularProgress,
  InputLabel,
  MenuItem,
  Select,
  CardHeader,
  Divider,
  Tooltip,
  OutlinedInput,
  Popover,
} from "@mui/material";
import { DataGridPro, gridClasses } from "@mui/x-data-grid-pro";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { SessionContext } from "../../../../contexts/SessionContext";
import { SnackbarProvider, useSnackbar } from "notistack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Chip from "@mui/material/Chip";
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css'
// import CardActions from "@mui/material/CardActions";
import CardMedia from "@mui/material/CardMedia";
import CheckIcon from "@mui/icons-material/Check";
import ListItemIcon from "@mui/material/ListItemIcon";
import Collapse from "@mui/material/Collapse";
import Switch from "@mui/material/Switch";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import PieChartIcon from "@mui/icons-material/PieChart";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import Chart from "react-apexcharts";
import axios from "axios";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NetPromoterScoreComingSoon from "../../../../assets/img/NetPromoterScoreComingSoon.jpg";
import stackedBarChartsComingSoon from "../../../../assets/img/stackedBarChartsComingSoon.jpg";
import HistogramsComingSoon from "../../../../assets/img/HistogramsComingSoon.jpg";

import { CSVLink, CSVDownload } from "react-csv";



// import DatabasesDialog from '../dialog/DatabasesDialog';

import positiveIcons from "../../../../assets/icons/positive.svg";
import neutralIcons from "../../../../assets/icons/neutral.svg";
import negativeIcons from "../../../../assets/icons/negative.svg";

import positivechart from "../../../../assets/icons/positivechart.png";
import neutralchart from "../../../../assets/icons/neutralchart.png";
import negativechart from "../../../../assets/icons/negativechart.png";

import demographyChart from "../../../../assets/icons/demographyChart.png";
import userIcon from "../../../../assets/icons/usericon.png";

import SplitterLayout from "react-splitter-layout";
import "react-splitter-layout/lib/index.css";
import DateFnsAdapter from "@mui/lab/AdapterDateFns";
import { DataGrid } from "@mui/x-data-grid";
import {
  churnRateRows,
  companyConsiderationColumnsData,
  companyConsiderationRows,
  companyTrustMetricColumnsData,
  companyTrustMetricRows,
  contactLevelRowsData,
  correspondenceRateRows,
  positiveSatisfactionColumnsData,
  positiveSatisfactionRowsData,
  sentimentResultColumnsData,
  sentimentResultRowsData,
  totalResultCountData,
} from "../../../../assets/data/result";
import { useTheme } from "@emotion/react";
import total_contacts from "../../../../assets/icons/usericon.svg";
import totalResponded from "../../../../assets/icons/totalResponded.svg";
import totalResponsePercent from "../../../../assets/icons/totalResponsePercent.svg";
import cltv from "../../../../assets/icons/cltv.svg";
import nps from "../../../../assets/icons/nps.svg";


import InsightIcons from "../../../../assets/icons/insightIcons.svg";
import SegmentationIcons from "../../../../assets/icons/segmentationIcons.svg";

import Checkbox from "@mui/material/Checkbox";

import addWeeks from "date-fns/addWeeks";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateRangePicker from "@mui/lab/DateRangePicker";

import { gridDataForGridRowData } from "../../../../assets/data/data";
import ReactWordcloud from "react-wordcloud";
import { de } from "date-fns/locale";
import { DateRangePickerComponent, PresetsDirective, PresetDirective } from '@syncfusion/ej2-react-calendars';
import InsightSegmentation from "../insight-segemetation";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";


function getWeeksAfter(date, amount) {
  return date ? addWeeks(date, amount) : undefined;
}

export default function MlResultsConnection({ resultData }) {
  const totalResultCount = totalResultCountData;
  const positiveSatisfactionColumns = positiveSatisfactionColumnsData;
  const positiveSatisfactionRows = positiveSatisfactionRowsData;
  const theme = useTheme();
  const [isSelectedPanel, setIsSelectedPanel] = useState("companyConsideration");

  const [chartHalf, setIschartHalf] = useState(4);
  const [chartHalfTs, setIschartHalfTs] = useState(4);
  const [chartBoxHeight, setIschartBoxHeight] = useState(230);
  const [chartHeight, setIschartHeight] = useState(230);
  const [showButton, setIsshowButton] = useState("d-inline-block");
  const [hideButton, setIshideButton] = useState("d-none");
  const [chartOne, setIschartOne] = useState("d-inline-block");
  const [chartOneCopy, setIschartOneCopy] = useState("d-none");

  const [chartHalfTM, setIschartHalfTM] = useState(4);
  const [chartBoxHeightTM, setIschartBoxHeightTM] = useState(250);
  const [chartHeightTM, setIschartHeightTM] = useState(250);
  const [showButtonTM, setIsshowButtonTM] = useState("d-inline-block");
  const [hideButtonTM, setIshideButtonTM] = useState("d-none");
  const [chartTwo, setIschartTwo] = useState("d-inline-block");
  const [labelHide, setlabelHide] = useState(false);


  const [chartHalfCR, setIschartHalfCR] = useState(4);
  const [chartBoxHeightCR, setIschartBoxHeightCR] = useState(230);
  const [chartHeightCR, setIschartHeightCR] = useState(230);
  const [showButtonCR, setIsshowButtonCR] = useState("d-inline-block");
  const [hideButtonCR, setIshideButtonCR] = useState("d-none");
  const [chartThree, setIschartThree] = useState("d-inline-block");
  const [chartThreeCopy, setIschartThreeCopy] = useState("d-none");

  const [chartHalfPC, setIschartHalfPC] = useState(4);
  const [chartBoxHeightPC, setIschartBoxHeightPC] = useState(250);
  const [chartHeightPC, setIschartHeightPC] = useState(250);
  const [showButtonPC, setIsshowButtonPC] = useState("d-inline-block");
  const [hideButtonPC, setIshideButtonPC] = useState("d-none");
  const [chartFour, setIschartFour] = useState("d-inline-block");
  const [chartFontSize, setIschartFontSize] = useState("7px");
  const [dataTable, setDataTable] = useState(true);
  const [filterBox, setfilterBox] = useState(false);
  const [errorFilterBox, seterrorFilterBox] = useState({ message: "", show: false });
  const [showLoderVisual, setLoderVisual] = useState(false);
  const [filterForBoxString, setfilterForBoxString] = useState("");

  const [selectedGridBox, setIsselectedGridBox] = useState("");
  const [isFilteredChurn, setisFilteredChurn] = useState("");

  const [mappingResultdata, setMappingResultdata] = useState([]);


  // const [timeframeSeriesList, settimeframeSeriesList] = useState([]);

  const [filterPopup, setfilterPopup] = useState({
    xPosition: 0,
    yPosition: 0,
  });


  const [finalClickInfo, setFinalClickInfo] = useState(null);

  const gridGridColumns = [
    {
      field: "name",
      headerName: "Name & Customer ID",
      flex: 1,
      minWidth: 120,
      editable: true,
      renderCell: (data) => {
        return (
          <div className="cell-template">
            <div className="float-left">{data.row.name} </div>
          </div>
        );
      },
    },
    {
      field: "sat_category",
      headerName:
        resultData.template == "Net Promoter Score"
          ? "Category"
          : "Customer Satisfaction",
      flex: 1,
      minWidth: 120,
      editable: true,
      headerAlign: "left",
      renderCell: (data) => {
        return (
          <div className="cell-template ">
            {(data.row.sat_category != undefined &&
              data.row.sat_category.toLowerCase() == "neutral") ||
              (data.row.sat_category != undefined &&
                data.row.sat_category.toLowerCase() == "passive") ? (
              <>
                <span className="medium">{data.row.sat_category}</span>
              </>
            ) : (
              ""
            )}
            {(data.row.sat_category != undefined &&
              data.row.sat_category.toLowerCase() == "positive") ||
              (data.row.sat_category != undefined &&
                data.row.sat_category.toLowerCase() == "promoter") ? (
              <>
                <span className="high">{data.row.sat_category}</span>
              </>
            ) : (
              ""
            )}
            {(data.row.sat_category != undefined &&
              data.row.sat_category.toLowerCase() == "negative") ||
              (data.row.sat_category != undefined &&
                data.row.sat_category.toLowerCase() == "detractor") ? (
              <>
                <span className="low">{data.row.sat_category}</span>
              </>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      field: "purchase_frequency",
      headerName: "Purchase Frequency",
      flex: 1,
      minWidth: 120,
      editable: true,
      hideable: true,
    },
    {
      field: "average_purchase_value",
      headerName: "Average Purchase Amount",
      flex: 1,
      minWidth: 100,
      editable: true,
    },
    {
      field: "cart_drop_rate",
      headerName: "Days Since Last Purchase",
      width: 100,
      editable: true,
    },
    {
      field: "age",
      headerName: "Age, Gender",
      flex: 1,
      minWidth: 120,
      editable: true,
      renderCell: (data) => {
        return (
          <div className="cell-template">
            <span className={data.row.hightLightclass}>
              {data.row.hightLighttext}
            </span>
            {data.row.gender}, {data.row.age}
          </div>
        );
      },
    },
    {
      field: "churn_risk",
      headerName: "Churn Risk",
      flex: 1,
      minWidth: 120,
      editable: true,
      renderCell: (data) => {
        return (
          <div className="cell-template">
            {data.row.churn_risk != undefined &&
              data.row.churn_risk.toLowerCase() == "medium" && (
                <>
                  <span className="churnMedium">{data.row.churn_risk}</span>
                </>
              )}
            {data.row.churn_risk != undefined &&
              data.row.churn_risk.toLowerCase() == "high" && (
                <>
                  <span className="churnHigh">{data.row.churn_risk}</span>
                </>
              )}
            {data.row.churn_risk != undefined &&
              data.row.churn_risk.toLowerCase() == "low" && (
                <>
                  <span className="churnLow">{data.row.churn_risk}</span>
                </>
              )}
          </div>
        );
      },
    },
    {
      field: "topics",
      headerName: "Topics",
      flex: 1,
      minWidth: 250,
      editable: true,
      renderCell: (data) => {
        return (
          <div className="cell-template" title={data.row.topics}>
            <p
              onClick={(event, value) => {
                data.row.ptag = !data.row.ptag;
              }}
              className={data.row.ptag ? "" : "ptag"}
            >
              {data.row.topics == undefined
                ? ""
                : data.row.topics.replace(/_/g, " ").replace(/'/g, "")}
            </p>
          </div>
        );
      },
    },
  ];
  const gridGridColumnswithoutHubspot = [
    {
      field: "name",
      headerName: "Name & Customer ID",
      flex: 1,
      minWidth: 120,
      editable: true,
      renderCell: (data) => {
        return (
          <div className="cell-template">
            {/* <img src={userIcon} alt="user" /> <br /> */}
            <div className="float-left">{data.row.name} </div>
          </div>
        );
      },
    },
    {
      field: "sat_category",
      headerName:
        resultData.template == "Net Promoter Score"
          ? "Category"
          : "Customer Satisfaction",
      flex: 1,
      minWidth: 120,
      editable: true,
      headerAlign: "left",
      renderCell: (data) => {
        return (
          <div className="cell-template ">
            {(data.row.sat_category != undefined &&
              data.row.sat_category.toLowerCase() == "neutral") ||
              (data.row.sat_category != undefined &&
                data.row.sat_category.toLowerCase() == "passive") ? (
              <>
                <span className="medium">{data.row.sat_category}</span>
              </>
            ) : (
              ""
            )}
            {(data.row.sat_category != undefined &&
              data.row.sat_category.toLowerCase() == "positive") ||
              (data.row.sat_category != undefined &&
                data.row.sat_category.toLowerCase() == "promoter") ? (
              <>
                <span className="high">{data.row.sat_category}</span>
              </>
            ) : (
              ""
            )}
            {(data.row.sat_category != undefined &&
              data.row.sat_category.toLowerCase() == "negative") ||
              (data.row.sat_category != undefined &&
                data.row.sat_category.toLowerCase() == "detractor") ? (
              <>
                <span className="low">{data.row.sat_category}</span>
              </>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      field: "topics",
      headerName: "Topics",
      flex: 1,
      minWidth: 250,
      editable: true,
      renderCell: (data) => {
        return (
          <div className="cell-template" title={data.row.topics}>
            <p
              onClick={(event, value) => {
                data.row.ptag = !data.row.ptag;
              }}
              className={data.row.ptag ? "" : "ptag"}
            >
              {data.row.topics == undefined
                ? ""
                : data.row.topics.replace(/_/g, " ").replace(/'/g, "")}
            </p>
          </div>
        );
      },
    },
    {
      field: "age",
      headerName: "Age, Gender",
      flex: 1,
      minWidth: 120,
      editable: true,
      renderCell: (data) => {
        return (
          <div className="cell-template">
            <span className={data.row.hightLightclass}>
              {data.row.hightLighttext}
            </span>
            {data.row.gender}, {data.row.age}
          </div>
        );
      },
    },
    {
      field: "churn_risk",
      headerName: "Churn Risk",
      flex: 1,
      minWidth: 120,
      editable: true,
      renderCell: (data) => {
        return (
          <div className="cell-template">
            {data.row.churn_risk != undefined &&
              data.row.churn_risk.toLowerCase() == "medium" && (
                <>
                  <span className="churnMedium">{data.row.churn_risk}</span>
                </>
              )}
            {data.row.churn_risk != undefined &&
              data.row.churn_risk.toLowerCase() == "high" && (
                <>
                  <span className="churnHigh">{data.row.churn_risk}</span>
                </>
              )}
            {data.row.churn_risk != undefined &&
              data.row.churn_risk.toLowerCase() == "low" && (
                <>
                  <span className="churnLow">{data.row.churn_risk}</span>
                </>
              )}
          </div>
        );
      },
    },
  ];

  const [isHidePositiveSatisfaction, setIsHidePositiveSatisfaction] = useState(true);
  const [companyConsidration, setCompanyConsidration] = useState({
    chartSeries: [],
    labels: [],
    overall: "",
    gridData: [],
    gridDataCols: [],
  });
  const [companyTrustMatrix, setCompanyTrustMatrix] = useState({
    chartSeries: [],
    labels: [],
    overall: "",
    categoriesList: [],
    selectedCat: "",
    originalData: null
  });

  const [correspondenceAnalysis, setCorrespondenceAnalysis] = useState({
    chartSeries: [],
    labels: [],
    overall: "",
    xLable: "",
    gridData: [],
    gridDataCols: [],
    tootltipProp: [],
  });

  const [churnRate, setChurnRate] = useState({
    chartSeries: [],
    labels: [],
    overall: "",
    originalData: [],
    selectedChurnCat: ""
  });

  const [kpiResult, setkpiResult] = useState([]);

  const [listOfColumnAthena, setlistOfColumnAthena] = useState([]);

  const [satisfactionResult, setsatisfactionResultResult] = useState({
    overall: "",
    positive: "",
    negative: "",
    neutral: "",
  });

  const [timeSeriesData, settimeSeriesData] = useState({
    chartSeries: [],
    labels: [],
    originalData: [],
    selectedTimeSeriesCat: [],
    selectedTimeSeriesTime: "",
    selectedTimeSeriesTimeOption: []
  });

  const [topicSentimentResult, settopicSentimentResult] = useState([]);
  const [topicSentimentResult1, settopicSentimentResult1] = useState([]);

  const [positiveSatisfactionTable, setpositiveSatisfactionTable] = useState("");
  const [isHubspotMerge, setisHubspotMerge] = useState(false);
  const [showLoder, setLoaderShow] = useState(false);

  const [showLoderSegmentation, setLoaderShowSegmentation] = useState(false);
  const intervalForSegmentationFilter = React.useRef();

  const [topicSentimentLabel, settopicSentimentLabel] = useState([]);
  const [selectionTool, setselectionTool] = useState([true]);


  const [positiveSatisfactionResult, setpositiveSatisfactionResult] = useState({
    filterdRow: [],
    filterdCol: [],
  });

  const [demographicsResult, setdemographicsResult] = useState({
    chartSeries: [],
    labels: [],
    chartData: null,
    categoriesList: [],
    selectedCat: ""
  });

  const [revenueARRResult, setrevenueARRResult] = useState({
    chartSeries: [],
    labels: [],
  });

  const [optionSurveyListForFilter, setoptionSurveyListForFilter] = useState([]);
  const [selectedSurveyListForFilter, setselectedSurveyListForFilter] = useState({ form_ids: [] });

  const [openSegmentation, setopenSegmentation] = useState(false);
  const [mappingCrossTabQuestion, setMappingCrossTabQuestion] = useState([]);
  const [mappingListCrossTab, setMappingListCrossTab] = useState({});



  const [openInsight, setopenInsight] = useState(false);
  const [generativeInsights, setGenerativeInsights] = useState("");

  // const dataColumns = [
  //   {
  //     id: 1,
  //     name: "Praesent.",
  //   },
  //   {
  //     id: 2,
  //     name: "Fix Styling",
  //   }, 
  // ];
  const [isCreateOpenSegmentation, setIsCreateOpenSegmentation] = useState(false);

  const [iscreateOverflow, setIscreateOverflow] = useState('hidden');
  const [selectedSegmentationOption, setselectedSegmentationOption] = useState({});
  // const [selectedSegmentationcolumns, setselectedSegmentationcolumns] = useState({ 
  //   'abcd': { 
  //      items: dataColumns,
  //    },
  //    'ss': { 
  //      items: [],
  //    },
  //   });


  const [segmentationCategoryMapping, setsegmentationCategoryMapping] = useState([{ ques: 'Overall Response', tab_name: 'Overall Response' }]);




  const chartOptions = {
    chart: {
      events: {
        dataPointSelection: function (event, chartContext, config) {
          console.log("ssssss+++++++++++");
          // let newGridObj = { ...gridDataForChurn }
          // let filterdData = newGridObj.rows.filter(ele => ele.status === config.w.config.labels[config.dataPointIndex]);
          // setGridFilterDataForChurn({
          //   columns: newGridObj.columns,
          //   rows: filterdData
          // })
        },
      },
      background: "transparent",
      width: 400,
      height: "auto",
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      fontSize: "14px",
      fontFamily: "Helvetica, Arial, sans-serif",
      fontWeight: "bold",
      colors: " #f00f00",
    },
    xaxis: {
      categories: companyConsidration.labels,
      labels: {
        show: true,
        rotate: -45,
        rotateAlways: true,
        hideOverlappingLabels: false,
        showDuplicates: false,
        trim: true,
        minHeight: undefined,
        width: 50,
        maxWidth: 50,
        maxHeight: 120,
        fill: "#000000",
        style: {
          fontSize: chartFontSize,
          with: "150px",
          color: "#000000",
          colors: "black",
          wordWrap: "break-word",
          fontWeight: 400,
          cssClass: "apexcharts-xaxis-label",
        },
      },
    },
  };

  const chartOptionsTimeSeries = {
    chart: {
      zoom: { enabled: false, },
      animations: {
        enabled: false // Set this to false
      },
      height: 350,
      type: 'line',
      dropShadow: {
        enabled: false,
        color: '#000',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2
      },

      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false | '<img src="/static/icons/reset.png"  alt="convertml" width="20">',
          customIcons: []
        },
      },
    },
    // colors: ['#77B6EA', '#545454'],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth'
    },
    title: {
      text: '',
      align: ''
    },
    grid: {

    },
    markers: {
      size: 1
    },
    legend: {
      horizontalAlign: 'left',
    },
    xaxis: {
      type: 'datetime',
      categories: timeSeriesData.labels,
      title: {
        text: 'Date'
      }
    },
    yaxis: {
      title: {
        text: 'Average Score'
      },
      // min: 5,
      // max: 40
    },
    // legend: {
    //   position: 'top',
    //   horizontalAlign: 'right',
    //   floating: true,
    //   offsetY: -25,
    //   offsetX: -5
    // }
  };

  const piechartOptions = {
    chart: {
      animations: {
        enabled: false // Set this to false
      },
    },
    labels: demographicsResult.labels,
    colors: ["#7FECA0", "#3AD475", "#FC495C", "#FCB12B", "#FAD557", "#72A3FC"],
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      offsetX: 0,
      offsetY: 0,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "45%",
        },
      },
    },
  };

  const polarAreachartOptions = {
    chart: {
      foreColor: "#ffffff",
      type: "donut",
    },
    labels: demographicsResult.labels,
    // labels: ['Rose A', 'Rose B', 'Rose C', 'Rose D', 'Rose E'],
    fill: {
      opacity: 1,
    },
    stroke: {
      width: 2,
      colors: "#ffffff",
    },
    yaxis: {
      show: false,
    },
    legend: false,
    // legend: {
    //   position: 'bottom'
    // },
    plotOptions: {
      pie: {
  
        donut: {
          size: "60%",
          expandOnClick: true
        },
      },

    },
    theme: {
      monochrome: {
        //    enabled: true,
        shadeTo: "dark",
        shadeIntensity: 0.9,
      },
    },
  };

  // '#3AD475', '', '#FC495C'
  const sentimentBasedOptionsNps = {
    chart: {
      type: "bar",
      height: 350,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        let colorInd = revenueARRResult.chartSeries[seriesIndex].data.findIndex(
          (ele) => ele == value
        );
        if (colorInd == 0) {
          return "#FA3E00";
        } else if (colorInd == 1) {
          return "#00C6E7";
        } else {
          return "#00E938";
        }
      },
    ],
    plotOptions: {
      bar: {
        borderRadius: 5,
        barHeight: "70%",
        horizontal: true,
      },
    },
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    title: {
      //text: ' '
    },
    dataLabels: {
      enabled: false,

    },

    tooltip: {

      fixed: {
        enabled: true,
        position: 'topRight',
        offsetX: 0,
        offsetY: 0,
      },
      y: {
        // formatter: function (val) {
        //   return val + "K"
        // }
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      // offsetX: 40,
    },

    xaxis: {
      categories: revenueARRResult.labels,
      labels: {
        show: true,
        rotate: -35,
        rotateAlways: true,
        // hideOverlappingLabels: true,
        // showDuplicates: false,
        // trim: true,
        minHeight: undefined,
        // width: 350,
        // maxWidth: 550,

        style: {
          width: "250px",
          wordWrap: "break-word",
          fontWeight: 400,
          cssClass: "apexcharts-xaxis-label",
        },
        formatter: function (value) {
          if (value >= 1000000000) {
            return (value / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
          }
          if (value >= 1000000) {
            return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
          }
          if (value >= 1000) {
            return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
          }
          return value;
        }
      },
    },
    toolbar: {
      show: true,
    },
    yaxis: {
      labels: {
        show: true,
        align: "left",
        maxWidth: 200,
        style: {
          // colors: '#f00f00',
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: 400,
          cssClass: "apexcharts-yaxis-label",
        },
        offsetX: 0,
        offsetY: 0,
        rotate: 0,
      },
    },
  };

  const [radarmaxValue, setradarmaxValue] = useState([]);
  const chartOptions1 = {
    chart: {
      events: {
        dataPointSelection: function (event, chartContext, config) {
          console.log("ssssss+++++++++++");
          // let newGridObj = { ...gridDataForChurn }
          // let filterdData = newGridObj.rows.filter(ele => ele.status === config.w.config.labels[config.dataPointIndex]);
          // setGridFilterDataForChurn({
          //   columns: newGridObj.columns,
          //   rows: filterdData
          // })
        },
      },
      background: "transparent",
      width: 400,
      height: "auto",
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    zoom: { enabled: false, },
    fill: {
      colors: ["#9B86EF", "#9B86EF", "#9B86EF"],
    },
    xaxis: {
      categories: companyTrustMatrix.labels,
      labels: {
        show: labelHide,
        rotate: -45,
        rotateAlways: true,
        hideOverlappingLabels: false,
        showDuplicates: false,
        trim: true,
        minHeight: undefined,
        width: 50,
        maxWidth: 50,
        maxHeight: 120,

        style: {
          //colors: 'red',
          // fontSize: chartFontSize, 
          width: "100px",
          wordWrap: "break-word",
          fontWeight: 400,
          cssClass: "apexcharts-xaxis-label",
        },
      },
    },
    yaxis: {
      min: -1.5,
      max: radarmaxValue,
      labels: {
        formatter: function (val) {
          return val.toFixed(2);
        },
      },
    },
  };

  const chartOptions2 = {
    chart: {
      animations: {
        enabled: false // Set this to false
      },
      height: 350,
      type: "scatter",
      selection: {
        enabled: selectionTool,
        type: "xy",
        fill: {
          color: "#24292e",
          opacity: 0.4,
        },
        stroke: {
          width: 1,
          dashArray: 3,
          color: "#24292e",
          opacity: 0.4,
        },
        xaxis: {
          min: 0,
          max: 0,
        },
        yaxis: {
          min: 0,
          max: 0,
        },
      },
      toolbar: {
        show: false,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
          customIcons: [
            {
              icon: '',
              index: 1,
              title: 'Refresh',
              class: 'cursor-pointer fa fa-refresh',
              click: function (chart, options, e) {
                setselectionTool(false)
                setTimeout(() => {
                  setselectionTool(true)
                }, 1)
              }
            }]
        }
      },
      zoom: {
        enabled: true,
        type: "xy",
        autoScaleYaxis: true,
        zoomedArea: {
          fill: {
            color: '#90CAF9',
            opacity: 0.4
          },
          stroke: {
            color: '#0D47A1',
            opacity: 0.4,
            width: 1
          }
        }//CAST(mean as DOUBLE) BETWEEN
      },
      autoSelected: 'zoom',
      events: {
        selection: async function (chartContext, { xaxis, yaxis }) {
          let aa1 = {
            xmin: xaxis.min,
            xmax: xaxis.max,
            ymin: yaxis.min,
            ymax: yaxis.max,
          };
          if (
            aa1.xmin != null &&
            aa1.xmax != null &&
            aa1.ymin != null &&
            aa1.ymax != null
          ) {
            let aa2 = ` WHERE CAST(mean as DOUBLE) BETWEEN ${aa1.xmin} AND ${aa1.xmax} AND CAST(pc2 as DOUBLE) BETWEEN ${aa1.ymin} AND ${aa1.ymax}`;
            getSatisfactionResult(
              positiveSatisfactionTable,
              aa2,
              isHubspotMerge,
              listOfColumnAthena
            );
          }
        },
      },
    },
    // states: {
    //   normal: {
    //     filter: {
    //       type: "none",
    //       value: 0,
    //     },
    //   },
    //   hover: {
    //     filter: {
    //       type: "lighten",
    //       value: 0.15,
    //     },
    //   },
    //   active: {
    //     allowMultipleDataPointsSelection: true,
    //     filter: {
    //       type: "darken",
    //       value: 0.35,
    //     },
    //   },
    // },
    // dataLabels: {
    //   enabled: false,
    //   textAnchor: "middle",
    //   offsetX: 0,
    //   offsetY: 10,
    //   background: {
    //     enabled: false,
    //   },
    // },
    grid: {
      show: false,
    },
    xaxis: {
      type: "numeric",
      min: 0,
      max: 6,
      tickAmount: 5,
      labels: {
        formatter: function (val) {
          return parseInt(val);
        },
      },
      title: {
        text: correspondenceAnalysis.xLable,
      },

    },

    yaxis: {
      min: -3,
      max: 4,
      tickAmount: 5,
      labels: {
        formatter: function (val) {
          return parseInt(val);
        },
      },
      title: {
        text: "PC2",
      },
    },

    tooltip: {
      show: false,
      // tooltipData:{"average_purchase_value":average_purchase_value,"purchase_frequency":purchase_frequency},
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        if (isHubspotMerge) {
          return (
            '<div class="arrow_box py-2 px-2 bg-blue text-white">' +
            "<span>Average Purchase Value: " +
            correspondenceAnalysis.tootltipProp[seriesIndex].data[
              dataPointIndex
            ].average_purchase_value +
            "</span><br/>" +
            "<span>Purchase Frequency: " +
            correspondenceAnalysis.tootltipProp[seriesIndex].data[
              dataPointIndex
            ].purchase_frequency +
            "</span><br/>" +
            "<span>Mean: " +
            correspondenceAnalysis.tootltipProp[seriesIndex].data[
              dataPointIndex
            ].mean +
            "</span><br/>" +
            "</div>"
          );
        } else {
          return (
            '<div class="arrow_box py-2 px-2 bg-blue text-white">' +
            "<span>Mean: " +
            correspondenceAnalysis.tootltipProp[seriesIndex].data[
              dataPointIndex
            ].mean +
            "</span><br/>" +
            "</div>"
          );
        }
      },
    },
  };

  const chartOptions3 = {

    chart: {
      type: 'boxPlot',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    title: {
      text: '',
      align: 'left'
    },
    plotOptions: {
      boxPlot: {
        colors: {
          upper: '#5C4742',
          lower: '#A5978B'
        }
      }
    },

  }


  const optionsWordCloud = {
    //colors: ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b"],
    // enableTooltip: false,
    // deterministic: true,
    // fontFamily: "Manrope",
    // fontSizes: [15, 40],
    // fontStyle: "normal",
    // fontWeight: "normal",
    // padding: 4, 
    // rotations: 5,
    // rotationAngles: [0, 180],
    // scale: "sqrt",
    // spiral: "archimedean",
    // transitionDuration: 500,
    // zoom: { enabled: true, } 
    enableTooltip: true,
    deterministic: false,
    fontFamily: "Manrope",
    fontSizes: [18, 32],
    // fontStyle: "normal",
    // fontWeight: "normal",
    padding: 4,
    rotations: 3,
    rotationAngles: [0, -90],
    scale: "sqrt",
    spiral: "archimedean",
    transitionDuration: 1000,

  };

  // getWordColor: word => word.value > 50 ? "blue" : "red",
  // onWordMouseOver: console.log,
  // getWordTooltip: word => `${word.text} (${word.value}) [${word.value > 50 ? "good" : "bad"}]`,
  const callbacks = {
    getWordColor: word => word.color,
    onWordClick: fetchSelectedWordCloudInfo("onWordClick"),
   // onWordMouseOver: console.log,
    getWordTooltip: word => `${word.text} (${word.value})`,
  }

  function fetchSelectedWordCloudInfo(callback) {
    return function (word, event) {
      let newresponsId = word.responseIds.map(x => `'${x}'`).toString();
      if (word.responseIds != undefined && word.responseIds.length != 0) {
        getFilteredResult(` WHERE response_id IN( ${newresponsId} )`)
      }
    }
  }

  const getFilteredResult = (wherequery) => {
    setIsselectedGridBox(wherequery);
    getSatisfactionResult(
      positiveSatisfactionTable,
      wherequery,
      isHubspotMerge,
      listOfColumnAthena
    );
  };

  const getSatisfactionResult = async (
    tableDetails,
    wherequery,
    hubspotMergeStatus,
    queryList
  ) => {
    let newTableDetail = tableDetails.split(".");
    setLoaderShow(true);
    let categoryCols =
      resultData.template == "Net Promoter Score"
        ? "nps_category"
        : "sat_category";

    await axios
      .post(`${process.env.REACT_APP_API_URL}/survey/getSurveyAthena`, {
        databaseName: newTableDetail[0],
        query:
          "SELECT " +
          queryList.join(",").toLowerCase() +
          " FROM " +
          newTableDetail[1],
        whereQuery: wherequery,
      })
      .then(async (response1) => {
        setLoaderShow(false);
        if (response1.data.success) {
          let newArrr1 = response1.data.data.map((ele, ind) => ({
            ...ele,
            id: ind + 1,
            ptag: false,
            sat_category:
              categoryCols == "nps_category"
                ? ele.nps_category
                : ele.sat_category,
          }));
          let csCol = (gridGridColumns.filter(ele => queryList.indexOf(ele.field) != -1));
          let npsCols = (gridGridColumnswithoutHubspot.filter(ele => queryList.indexOf(ele.field) != -1));
          setpositiveSatisfactionResult({
            filterdRow: (csCol.length == 0 || npsCols.length == 0 ? [] : newArrr1),
            filterdCol: hubspotMergeStatus
              ? csCol : npsCols,
          });

          if (wherequery == null && queryList.indexOf("PC1") != -1) {
            let getAllCluster = response1.data.data.map((ele) => ele.cluster);
            const listAllCluster = [...new Set(getAllCluster)];
            const seriesData = [];
            const seriesData1 = [];
            await listAllCluster.forEach((ele) => {
              let matchedCluster = {
                name: ele,
                color: ele == 1 ? "#FEAC00" : ele == 2 ? "#FA586C" : "#10BA5C",
                data: response1.data.data
                  .filter((ele1) => ele1.cluster == ele)
                  .map((ele2) => [
                    parseFloat(ele2.mean).toFixed(3),
                    parseFloat(ele2.pc2).toFixed(3),
                  ]),
              };
              seriesData.push(matchedCluster);
            });

            await listAllCluster.forEach((ele) => {
              let matchedCluster = {
                name: ele,
                data: response1.data.data
                  .filter((ele1) => ele1.cluster == ele)
                  .map((ele2) => ({
                    average_purchase_value: ele2.average_purchase_value,
                    purchase_frequency: ele2.purchase_frequency,
                    mean: ele2.mean,
                    pc1: parseFloat(ele2.pc1).toFixed(3),
                    pc2: parseFloat(ele2.pc2).toFixed(3),
                  })),
              };
              seriesData1.push(matchedCluster);
            });

            let clusterAnalysisXlable =
              resultData.template == "Net Promoter Score"
                ? "Likelihood in clustering analysis."
                : "Satisfaction";
            setCorrespondenceAnalysis({
              chartSeries: seriesData,
              labels: [],
              overall: "",
              xLable: clusterAnalysisXlable,
              gridData: [],
              gridDataCols: [],
              tootltipProp: seriesData1,
            });
          }
        } else {
          //  setToastObject({
          //     message: t(`${res.message}`),
          //     severity: "error",
          //     open: true,
          //   });
        }
      })
      .catch((err) => { });
  };

  const fetchSurveyResult = () => {
    fetch(`${process.env.REACT_APP_API_URL}/survey/viewResult`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        project_name: resultData.project_name,
        user_id: resultData.user_id,
        template: resultData.template,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success === true && res.data.length != 0) {
          let mappingResult = res.data[res.data.length - 1].analysis_result;
          setMappingResultdata(mappingResult)
          let mappingCrossTab1 = res.data[res.data.length - 1].cross_tab;
          let mappingCrossTab = (typeof mappingCrossTab1 == "string") ? JSON.parse(mappingCrossTab1) : mappingCrossTab1;
          let mappingInsight = res.data[res.data.length - 1].generative_insights;
          if (mappingCrossTab != undefined) {
            // setMappingCrossTabQuestion(res.data.crosstab);
            if (mappingCrossTab.mapping_list != undefined) {
              if (mappingCrossTab.mapping_list.length == 0) {
                let mappingCrossTabQuestion = Object.keys(Object.assign({}, ...mappingCrossTab.crosstab));
                let newMappingCorssObj = mappingCrossTabQuestion.map((ele, ind) => ({ tableHeader: [ele, "Respondent"], tableRow: (mappingCrossTab.crosstab[ind][ele] == undefined ? [] : (Object.entries(mappingCrossTab.crosstab[ind][ele]))) }));
                setMappingCrossTabQuestion(newMappingCorssObj)
              } else {
                setMappingCrossTabQuestion(mappingCrossTab.crosstab)
              }
              let tmpMappingObj = {}
              mappingCrossTab.mapping_list.forEach(ele => {
                tmpMappingObj[ele.tab_name] = ele.ques;
              })
              setMappingListCrossTab(tmpMappingObj);
              let tmpsegmentationCategoryMapping = mappingCrossTab.mapping_list;
              tmpsegmentationCategoryMapping.push({ ques: 'Overall Response', tab_name: 'Overall Response' })
              setsegmentationCategoryMapping(tmpsegmentationCategoryMapping);
            } else {
              let mappingCrossTabQuestion = Object.keys(Object.assign({}, ...mappingCrossTab));
              let newMappingCorssObj = mappingCrossTabQuestion.map((ele, ind) => ({ tableHeader: [ele, "Respondent"], tableRow: (Object.entries(mappingCrossTab[ind][ele])) }));
              setMappingCrossTabQuestion(newMappingCorssObj)
            }

          }

          if (mappingInsight != undefined) {
            setGenerativeInsights(mappingInsight);
          }

          let newKpi = Object.keys(mappingResult.kpis);
          let newKpi1 = newKpi
            .filter(function (value) {
              return mappingResult.kpis[value] != "null";
            })
            .map((ele) => ({
              label: ele,
              count: mappingResult.kpis[ele],
              displayName: ele.split("_").join(" "),
            }));
          setkpiResult(newKpi1);

          //////for time series/////////
          if (mappingResult.timeseries != undefined && mappingResult.timeseries != "null") {
            let tmpTimeSeriesData1 = mappingResult.timeseries == undefined ? [] : Object.values(mappingResult.timeseries);
            let tmpTimeSeriesData = [];
            let newTimeKey = tmpTimeSeriesData1.length == 0 ? [] : (Object.keys(tmpTimeSeriesData1[0].data));
            tmpTimeSeriesData1.forEach(ele => {
              let newData = {}
              newTimeKey.forEach(el => {
                let timeSt = [];
                let timeVal = []
                ele.data[el].values.forEach((eel1, ind) => {
                  if (eel1 != null) {
                    timeVal.push(eel1)
                    timeSt.push(ele.data[el].timestamp[ind])
                  }
                })
                newData[el] = { timestamp: timeSt, values: timeVal }
              })
              tmpTimeSeriesData.push({ data: newData, label: ele.label });
            })
            let newOption = newTimeKey.map(ele => ({ name: ele.charAt(0).toUpperCase() + ele.slice(1), value: ele }))
            let tmpSeriesData = [];
            // let nullInd = []  .map(elenotNull=>elenotNull!=null)
            tmpTimeSeriesData.forEach(ele => {
              tmpSeriesData.push({ name: ele.label, data: (ele.data[newTimeKey[0]].values) })
            })

            let newTimeSeriesDataObj = {
              chartSeries: tmpSeriesData,
              labels: tmpTimeSeriesData[0].data[newTimeKey[0]].timestamp,
              originalData: tmpTimeSeriesData,
              selectedTimeSeriesCat: tmpTimeSeriesData.map(ele => ele.label),
              selectedTimeSeriesTime: newTimeKey[0],
              selectedTimeSeriesTimeOption: newOption
            }
            settimeSeriesData(newTimeSeriesDataObj);
          }
          //////for time series/////////

          if (resultData.template == "Net Promoter Score" && resultData.template != 'null') {
            setsatisfactionResultResult({
              overall: 0,
              positive: mappingResult.overall_satisfaction.positive,
              negative: mappingResult.overall_satisfaction.negative,
              neutral: mappingResult.overall_satisfaction.neutral,
            });
          } else {
            setsatisfactionResultResult({
              overall:
                mappingResult.overall_satisfaction.overall == undefined
                  ? 0
                  : mappingResult.overall_satisfaction.overall.toFixed(2),
              positive: mappingResult.overall_satisfaction.positive.toFixed(2),
              negative: mappingResult.overall_satisfaction.negative.toFixed(2),
              neutral: mappingResult.overall_satisfaction.neutral.toFixed(2),
            });
          }

          if (mappingResult.topic_sentiment != undefined && mappingResult.topic_sentiment != "null") {
            let newTopic = Object.keys(mappingResult.topic_sentiment);
            let newTopic1 = newTopic.map((ele) => ({
              topic: ele.split("_").join(" "),
              positive: mappingResult.topic_sentiment[ele].positive,
              neutral: mappingResult.topic_sentiment[ele].neutral,
              negative: mappingResult.topic_sentiment[ele].negative,
            }));
            settopicSentimentResult1(newTopic1);
            settopicSentimentResult(newTopic1);
            settopicSentimentLabel(newTopic);
            setSelected(newTopic)
          }

          //////for Regression/////////
          if (mappingResult.regression != undefined && mappingResult.regression != "null") {
            let withoutoverAllTrust = { ...mappingResult.regression };
            let listOfCategory = Object.keys(withoutoverAllTrust);
            let selectedChartData1 = { ...withoutoverAllTrust };
            let selectedChartData = selectedChartData1[listOfCategory[0]];
            const cloneselectedChartData = (({ overall, ...o }) => o)(selectedChartData);
            let newAllTrustLable = Object.keys(cloneselectedChartData);
            let newAllTrustValue = Object.values(cloneselectedChartData);
            let maxValue = newAllTrustValue.reduce((a, b) => Math.max(a, b), -Infinity);
            setradarmaxValue(maxValue);
            setCompanyTrustMatrix({
              chartSeries: [
                {
                  name: selectedChartData.overall.label,
                  data: newAllTrustValue,
                },
              ],
              labels: newAllTrustLable,
              overall: selectedChartData.overall.value + "%",
              categoriesList: listOfCategory,
              selectedCat: listOfCategory[0],
              originalData: withoutoverAllTrust,
            });
          }
          //////for Regression/////////

          //////for Churn/////////

          if (mappingResult.word_cloud != undefined && mappingResult.word_cloud != "null") {
            let withoutoverAllChurnData = { ...mappingResult.word_cloud };
            let listOfCategory = Object.keys(withoutoverAllChurnData);
            let selectedChartData1 = { ...withoutoverAllChurnData };
            let overAll = listOfCategory.filter(ele => ele == "Overall")
            let selectedChartData = selectedChartData1[overAll == 0 ? listOfCategory[0] : listOfCategory.filter(ele => ele == "Overall")];
            // let sortedLabel = selectedChartData.data.sort((a, b) => parseFloat(a) - parseFloat(b));
            let chartData = selectedChartData.labels.map((ele, ind) => ({ text: ele, value: selectedChartData.data[ind], color: (selectedChartData.color == undefined ? "#000" : selectedChartData.color[ind]), responseIds: (selectedChartData.response_id == undefined ? [] : selectedChartData.response_id[ind]) }))
            let chartData1 = (chartData.sort((a, b) => parseFloat(b.value) - parseFloat(a.value))).slice(0, 20)
            // console.log(chartData1)

            setChurnRate({
              chartSeries: chartData1,
              labels: listOfCategory,
              originalData: withoutoverAllChurnData,
              selectedChurnCat: (overAll == 0 ? listOfCategory[0] : listOfCategory.filter(ele => ele == "Overall"))
            });

          }

          //////for Churn/////////

          //////for Demographic/////////
          if (mappingResult.demographics != undefined && mappingResult.demographics != "null") {
            let newDemographicDataLable = Object.keys(
              mappingResult.demographics
            );
            let newDemographicDataValue = Object.values(
              mappingResult.demographics
            );
            setdemographicsResult({
              chartSeries: newDemographicDataValue,
              labels: newDemographicDataLable,
              chartData: null,
              categoriesList: [],
              selectedCat: newDemographicDataLable[0]
            });
          }

          if (mappingResult.pie_chart != undefined && mappingResult.pie_chart != 'null') {
            let listOfCategory = Object.keys(mappingResult.pie_chart);
            let listOfCategoryData = mappingResult.pie_chart[listOfCategory[0]];
            setdemographicsResult({
              chartSeries: listOfCategoryData.series,
              labels: listOfCategoryData.labels,
              chartData: mappingResult.pie_chart,
              categoriesList: listOfCategory,
              selectedCat: listOfCategory[0]
            });
          }
          //////for Demographic/////////

          if (mappingResult.category_revenue != undefined && mappingResult.category_revenue != "null") {
            let newRevenueArrLable = Object.keys(
              mappingResult.category_revenue
            );
            let newRevenueArrValue = Object.values(
              mappingResult.category_revenue
            );
            setrevenueARRResult({
              chartSeries: [
                {
                  name: "Revenue ARR",
                  data: newRevenueArrValue,
                },
              ],
              labels: newRevenueArrLable,
            });
          }

          setpositiveSatisfactionTable(mappingResult.positive_satisfaction_db_tbl);
          setisHubspotMerge(res.data[res.data.length - 1].hubspot_merged_status);
          setlistOfColumnAthena(mappingResult.query_list);
          getResultFromS3(res.data[res.data.length - 1].hubspot_merged_status,
            mappingResult.query_list)
          // getSatisfactionResult(
          //   mappingResult.positive_satisfaction_db_tbl,
          //   null,
          //   res.data[res.data.length - 1].hubspot_merged_status,
          //   mappingResult.query_list
          // );
        } else {
          // setToastObject({
          //   message: t(`${res.message}`),
          //   severity: "error",
          //   open: true,
          // });
        }
      });
  };
  const [selected, setSelected] = useState([]);
  const isAllSelected = topicSentimentLabel.length > 0 && selected.length === topicSentimentLabel.length;

  const handleChangefilter = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelected(selected.length === topicSentimentLabel.length ? [] : topicSentimentLabel);
      return;
    }
    setSelected(value);
    console.log(setSelected)
  };

  const chartenlarge = (selectChart) => {
    if (selectChart == "companyTs") {
      setIschartHalfTs(12);
      setIschartHalf(12);
      setIschartBoxHeight(600);
      setIschartHeight(600);
      setIshideButton("d-inline-block");
      setIsshowButton("d-none");
      setIschartFontSize("12px");
    }
    else if (selectChart == "companyC") {
      setIschartHalf(12);
      setIschartBoxHeight(600);
      setIschartHeight(600);
      setIshideButton("d-inline-block");
      setIsshowButton("d-none");
      setIschartFontSize("12px");
    } else if (selectChart == "companyTM") {
      setlabelHide(true);
      setIschartHalfTM(12);
      setIschartBoxHeightTM(600);
      setIschartHeightTM(600);
      setIshideButtonTM("d-inline-block");
      setIsshowButtonTM("d-none");
      setIschartOneCopy("d-inline-block");
      setIschartFontSize("12px");
    } else if (selectChart == "companyCR") {
      setIschartHalfCR(12);
      setIschartBoxHeightCR(600);
      setIschartHeightCR(600);
      setIshideButtonCR("d-inline-block");
      setIsshowButtonCR("d-none");
    } else if (selectChart == "companyPC") {
      if (mappingResultdata.word_cloud != undefined && mappingResultdata.word_cloud != "null") {
        let withoutoverAllChurnData = { ...mappingResultdata.word_cloud };
        let listOfCategory = Object.keys(withoutoverAllChurnData);
        let selectedChartData1 = { ...withoutoverAllChurnData };
        let overAll = listOfCategory.filter(ele => ele == "Overall")
        let selectedChartData = selectedChartData1[overAll == 0 ? listOfCategory[0] : listOfCategory.filter(ele => ele == "Overall")];
        let chartData = selectedChartData.labels.map((ele, ind) => ({ text: ele, value: selectedChartData.data[ind], color: (selectedChartData.color == undefined ? "#000" : selectedChartData.color[ind]), responseIds: (selectedChartData.response_id == undefined ? [] : selectedChartData.response_id[ind]) }))
        let chartData1 = (chartData.sort((a, b) => parseFloat(b.value) - parseFloat(a.value))).slice(0, 100)
        console.log(chartData1)

        setChurnRate({
          chartSeries: chartData1,
          labels: listOfCategory,
          originalData: withoutoverAllChurnData,
          selectedChurnCat: (overAll == 0 ? listOfCategory[0] : listOfCategory.filter(ele => ele == "Overall"))
        });
      }

      setIschartHalfPC(12);
      setIschartBoxHeightPC(600);
      setIschartHeightPC(600);
      setIshideButtonPC("d-inline-block");
      setIsshowButtonPC("d-none");
      setIschartThree("d-none");
      setIschartThreeCopy("d-inline-block");
    }
  };

  const hideDataTable = (e) => {
    if (positiveSatisfactionResult.filterdRow.length != 0) {
      setDataTable(!dataTable);
    }
  };

  const openFilterBox = (e, dialogHeader) => {
    e.stopPropagation();
    setfilterBox(true);
    setfilterPopup({
      xPosition: (e.pageX - (dialogHeader == "Dashboard" ? 250 : 200)),
      yPosition: (e.pageY + 10),
    })
    setfilterForBoxString(dialogHeader)
  };

  const closeFilterBox = () => {
    setfilterBox(false);
  };

  const openSegmentaionDialogBox = (e, dialogHeader) => {
    e.stopPropagation();
    setopenSegmentation(true);
    setfilterPopup({
      xPosition: (e.pageX - (dialogHeader == "Dashboard" ? 250 : 200)),
      yPosition: (e.pageY + 10),
    })
    setfilterForBoxString(dialogHeader)
    // getResultFromS3()

    /*---------- excel download ---------- */
    let exlheader = segmentationCategoryMapping.map((item, ind1) => {
      return item.ques.split("\n")[0]
    })
    exlheader.unshift('');
    setexcelHeader(exlheader)

    let newdata = []
    mappingCrossTabQuestion.forEach((item, ind2) => {
      newdata.push(item.tableHeader.map((itemn1, ii) => (itemn1.split("\n").length == 1 ? itemn1 : itemn1.split("\n")[1])))
      item.tableRow.forEach((item1, i) => {
        newdata.push(item1)
      })
    })
    setexcelRowData(newdata)
    /*---------- excel download end ---------- */

  };

  const closeSegmentaionDialogBox = () => {
    setopenSegmentation(false);
  };

  const getResultFromS3 = async (hubspotMergeStatus,
    queryList) => {
    let categoryCols =
      resultData.template == "Net Promoter Score"
        ? "nps_category"
        : "sat_category";
    axios
      .post(`${process.env.REACT_APP_API_URL}/s3/read`, {
        bucket: "convertml-test-data",
        key: `${resultData.user_id}/gold/contact_satisfaction_${resultData._id}.csv`
      })
      .then(async (responsee) => {
        if (responsee.data.success) {
          let response1a = CSVToJSON(responsee.data.data);
          let response1 = response1a.filter(ele => ele.response_id != "");
          // console.log("bbbbbbbbb", response1);
          let newArrr1 = response1.map((ele, ind) => ({
            ...ele,
            id: ind + 1,
            ptag: false,
            sat_category:
              categoryCols == "nps_category"
                ? ele.nps_category
                : ele.sat_category,
          }));
          let csCol = (gridGridColumns.filter(ele => queryList.indexOf(ele.field) != -1));
          let npsCols = (gridGridColumnswithoutHubspot.filter(ele => queryList.indexOf(ele.field) != -1));
          setpositiveSatisfactionResult({
            filterdRow: (csCol.length == 0 || npsCols.length == 0 ? [] : newArrr1),
            filterdCol: hubspotMergeStatus ? csCol : npsCols,
          });
          // wherequery == null && 
          if (queryList.indexOf("PC1") != -1) {
          let getAllCluster = response1.slice(1, 1000).map((ele) => ele.cluster);
          const listAllCluster = [...new Set(getAllCluster)];
          const seriesData = [];
          const seriesData1 = [];
          await listAllCluster.forEach((ele) => {
            let matchedCluster = {
              name: ele,
              color: ele == 1 ? "#FEAC00" : ele == 2 ? "#FA586C" : "#10BA5C",
              data: response1.slice(1, 1000)
                .filter((ele1) => ele1.cluster == ele)
                .map((ele2) => [
                  parseFloat(ele2.mean).toFixed(3),
                  parseFloat(ele2.PC2).toFixed(3),
                ]),
            };
            seriesData.push(matchedCluster);
          });

          await listAllCluster.forEach((ele) => {
            let matchedCluster = {
              name: ele,
              data: response1.slice(1, 1000)
                .filter((ele1) => ele1.cluster == ele)
                .map((ele2) => ({
                  average_purchase_value: ele2.average_purchase_value,
                  purchase_frequency: ele2.purchase_frequency,
                  mean: ele2.mean,
                  pc1: parseFloat(ele2.PC1).toFixed(3),
                  pc2: parseFloat(ele2.PC2).toFixed(3),
                })),
            };
            seriesData1.push(matchedCluster);
          });

          let clusterAnalysisXlable =
            resultData.template == "Net Promoter Score"
              ? "Likelihood in clustering analysis."
              : "Satisfaction";
          setCorrespondenceAnalysis({
            chartSeries: seriesData,
            labels: [],
            overall: "",
            xLable: clusterAnalysisXlable,
            gridData: [],
            gridDataCols: [],
            tootltipProp: seriesData1,
          });
          }
        } else {
          console.log(responsee.data.error.message)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const CSVToJSON = (csv) => {
    if (csv != undefined) {
      const lines = csv.split('\n');
      const keys = lines[0].replaceAll("\"", "").split(',');
      return lines.slice(1).map((line, ind) => {
        return line.split(/,(?=\S)/g).reduce((acc, cur, i) => {
          const toAdd = {};
          toAdd[keys[i]] = cur.replaceAll("\"", "");
          return { ...acc, ...toAdd };
        }, {});
      });
    }
  };

  const openInsightDialogBox = (e, dialogHeader) => {
    e.stopPropagation();
    setopenInsight(true);
    setfilterPopup({
      xPosition: (e.pageX - (dialogHeader == "Dashboard" ? 250 : 200)),
      yPosition: (e.pageY + 10),
    })
    setfilterForBoxString(dialogHeader);
    if (generativeInsights == "" || generativeInsights == "null") {
      fetch(`${process.env.REACT_APP_API_URL}/survey/viewResult`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          project_name: resultData.project_name,
          user_id: resultData.user_id,
          template: resultData.template,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("resultttoooooooooo", res);
          // setLoderVisual(false)
          if (res.success === true && res.data.length != 0) {
            let mappingInsight = res.data[res.data.length - 1].generative_insights;
            if (mappingInsight != undefined) {
              setGenerativeInsights(mappingInsight);
            }


          } else {
            // setToastObject({
            //   message: t(`${res.message}`),
            //   severity: "error",
            //   open: true,
            // });
          }
        });

    }

  };

  const closeInsightDialogBox = () => {
    setopenInsight(false);
  };

  const resetSegmentation = () => {
    let resetSegmentList = {}
    let obej1 = Object.values(columns);
    let obej2 = obej1.map(ele => ele.items).flat();
    obej2.forEach(ele => {
      resetSegmentList[ele.qus + "_" + ele.name] = { items: new Array({ id: ele.qus + ele.name, name: ele.name, qus: ele.qus }) };
    })

    setColumns(resetSegmentList);
  };

  const checkedSelectedSegmentation = (ques, option) => {
    let isSelected = ((Object.values(columns).map(ele => ele.items)).flat()).filter(ele => ele.qus == ques && ele.name == option)
    if (isSelected.length == 0) {
      return false;
    } else {
      return true
    }
  };


  const handleSelectSegmentOption = (ischecked, questionName, Options) => {
    let newSelectedSeg = { ...columns }
    let obej2 = Object.keys(columns)

    if (ischecked) {
      newSelectedSeg[questionName + '_' + Options] = { items: new Array({ id: questionName + Options, name: Options, qus: questionName }) }
    } else {
      obej2.forEach(ele => {
        newSelectedSeg[ele].items = newSelectedSeg[ele].items.filter(elefilter => elefilter.id != questionName + Options);
        if (newSelectedSeg[ele].items.length == 0) {
          delete newSelectedSeg[ele];
        }
      })
    }
    setColumns(newSelectedSeg);
  };

  
  const handleDeleteSegmentOption = (event, itemHeader,catInd) => {
    // handleSelectSegmentOption(false,itemHeader.ques,itemHeader.tab_name.split("\n")[1].trim())
    let tmpsegmentationCategoryMapping = [...segmentationCategoryMapping];
    let tmpmappingCrossTabQuestion = [...mappingCrossTabQuestion];
    tmpmappingCrossTabQuestion.forEach(ele=>{
      ele.tableHeader.splice(catInd+1,1);
      ele.tableRow.forEach(ele1=> {
        ele1 = ele1.splice(catInd+1,1)
      });
    })
    tmpsegmentationCategoryMapping.splice(catInd,1)
    setMappingCrossTabQuestion(tmpmappingCrossTabQuestion);
    setsegmentationCategoryMapping(tmpsegmentationCategoryMapping);

    let updateSegmentation = {crosstab:[],mapping_list:[]}

    let tmpSegList = []
    if(tmpsegmentationCategoryMapping.length==1){
      tmpmappingCrossTabQuestion.forEach(ele=>{
        let newObj = {};
        let newObj1 = {};
        ele.tableRow.forEach(ele1=> {
          newObj1[ele1[0]] = ele1[1]
        });
        newObj[ele.tableHeader[0]] = newObj1;
        tmpSegList.push(newObj);
      })
      updateSegmentation.crosstab = tmpSegList;
      updateSegmentation.mapping_list = [];
    }else{
      updateSegmentation.crosstab = tmpmappingCrossTabQuestion;
      updateSegmentation.mapping_list = tmpsegmentationCategoryMapping.filter(ele=>ele.ques!="Overall Response");
    }

    console.log("dddd");
    let newObj = {
      "project_name": resultData.project_name,
      "user_id": resultData.user_id,
      "template": resultData.template,
      "corssTabData": JSON.stringify(updateSegmentation),
    }

    fetch(`${process.env.REACT_APP_API_URL}/survey/deleteSegmentation`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(newObj),
    })
      .then((res) => res.json())
      .then((res) => {
        // console.log(res);
        if (res.success) {
          console.log(res.message);
        }

      }).catch((err) => {
        // setLoaderShowSegmentation(false);
      });;
  }

  const handleubmitSegmentOptionFilter = (ev) => {
    let newObj = {
      "project_name": resultData.project_name,
      "project_id": resultData._id,
      "user_id": resultData.user_id,
      "template": resultData.template,
      "mapping_json": resultData.mapping_json,
      "segments": columns,
    }

    fetch(`${process.env.REACT_APP_API_URL}/survey/filterSegmentation`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(newObj),
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        if (res.success) {
          setLoaderShowSegmentation(true);
        }

      }).catch((err) => {
        setLoaderShowSegmentation(false);
      });;
  }






  const closeenlarge = (selectChart) => {
    if (selectChart == "companyTs") {
      setIschartHalfTs(4);
      setIschartHalf(4);
      setIschartBoxHeight(230);
      setIschartHeight(230);
      setIshideButton("d-none");
      setIsshowButton("d-blok");
      setIschartFontSize("6px");
    }

    else if (selectChart == "companyC") {
      setIschartHalf(4);
      setIschartBoxHeight(250);
      setIschartHeight(250);
      setIshideButton("d-none");
      setIsshowButton("d-blok");
      setIschartFontSize("6px");
    } else if (selectChart == "companyTM") {
      setIschartHalfTM(4);
      setIschartBoxHeightTM(250);
      setIschartHeightTM(250);
      setIshideButtonTM("d-none");
      setIsshowButtonTM("d-blok");
      setIschartOne("d-inline-block");
      setIschartOneCopy("d-none");
      setIschartFontSize("6px");
      setlabelHide(false);
    } else if (selectChart == "companyCR") {
      setIschartHalfCR(4);
      setIschartBoxHeightCR(230);
      setIschartHeightCR(230);
      setIshideButtonCR("d-none");
      setIsshowButtonCR("d-blok");
      setIschartFontSize("6px");
    } else if (selectChart == "companyPC") {
      if (mappingResultdata.word_cloud != undefined && mappingResultdata.word_cloud != "null") {
        let withoutoverAllChurnData = { ...mappingResultdata.word_cloud };
        let listOfCategory = Object.keys(withoutoverAllChurnData);
        let selectedChartData1 = { ...withoutoverAllChurnData };
        let overAll = listOfCategory.filter(ele => ele == "Overall")
        let selectedChartData = selectedChartData1[overAll == 0 ? listOfCategory[0] : listOfCategory.filter(ele => ele == "Overall")];
        let chartData = selectedChartData.labels.map((ele, ind) => ({ text: ele, value: selectedChartData.data[ind], color: (selectedChartData.color == undefined ? "#000" : selectedChartData.color[ind]), responseIds: (selectedChartData.response_id == undefined ? [] : selectedChartData.response_id[ind]) }))
        let chartData1 = (chartData.sort((a, b) => parseFloat(b.value) - parseFloat(a.value))).slice(0, 20)
        console.log(chartData1)

        setChurnRate({
          chartSeries: chartData1,
          labels: listOfCategory,
          originalData: withoutoverAllChurnData,
          selectedChurnCat: (overAll == 0 ? listOfCategory[0] : listOfCategory.filter(ele => ele == "Overall"))
        });
      }
      setIschartHalfPC(4);
      setIschartBoxHeightPC(250);
      setIschartHeightPC(250);
      setIshideButtonPC("d-none");
      setIsshowButtonPC("d-blok");
      setIschartThree("d-inline-block");
      setIschartThreeCopy("d-none");
      setIschartFontSize("6px");
    }
  };


  // const timeframeList = [
  //   { name: "Yearly", value: "Yearly" },
  //   { name: "Quarterly", value: "Quarterly" },
  //   { name: "Monthly", value: "Monthly" },
  //   { name: "Custom Period", value: "Custom Period" },
  // ];

  // const timeframeSeriesList = [
  //   { name: "Hourly", value: "hourly" },
  //   { name: "Daily", value: "day" },
  //   { name: "Monthly", value: "month" },
  //   { name: "Quarterly", value: "quarter" },
  //   { name: "Yearly", value: "year" },
  // ];

  const [filterDateRange, setfilterDateRange] = React.useState([new Date(), new Date()]);
  const [surveyNames, setsurveyNames] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setsurveyNames(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split('/') : value,
    );
  };



  const selectSurveyForGlobalFilter = (e, value, isTime) => {

    let tmpselectedSurveyListForFilter = { ...selectedSurveyListForFilter };
    // let tmp1 = optionSurveyListForFilter.filter(ele => ele.value==value)

    if (tmpselectedSurveyListForFilter.form_ids.indexOf(value) == -1) {
      tmpselectedSurveyListForFilter.form_ids.push(value)
    } else {
      tmpselectedSurveyListForFilter.form_ids.splice(tmpselectedSurveyListForFilter.form_ids.indexOf(value), 1)
    }
    setselectedSurveyListForFilter(tmpselectedSurveyListForFilter);
  };

  const filterGlobalFilterOk = () => {
    setLoderVisual(true);
    let getSelectedFormId = optionSurveyListForFilter.filter((ele) => selectedSurveyListForFilter.form_ids.indexOf(ele.label) != -1);
    let tmpGlobalGloblTmp = { form_ids: getSelectedFormId.map(ele => ele.value), date_filter: filterDateRange }
    fetch(`${process.env.REACT_APP_API_URL}/survey/createSurvey`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        projectName: resultData.project_name,
        form_id: getSelectedFormId,
        user_id: resultData.user_id,
        template: resultData.template,
        mapping_json: resultData.mapping_json,
        saveAsDraft: true,
        savedScreen: resultData.savedScreen,
        selectedProjectId: resultData._id,
        filters: tmpGlobalGloblTmp,
        selectedSurvey: selectedSurveyListForFilter.form_ids
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoderVisual(false);
        if (res.success) {
          seterrorFilterBox({ message: "", show: false })
          closeFilterBox();
          fetchSurveyResult()
        } else {
          let newMessg = JSON.parse(res.message)

          let newfilterMessg = newMessg.error == undefined ? (newMessg[0].error.short_text + ":\r\n\r" + newMessg[0].error.message) : newMessg.error.message;
          seterrorFilterBox({ message: newfilterMessg, show: true });
        }

      });
  }

  const selectCatTimeSeries = (e, value, isTime) => {
    let tmptimeSeriesData = { ...timeSeriesData };
    if (isTime) {
      tmptimeSeriesData.selectedTimeSeriesTime = value
    } else {
      if (tmptimeSeriesData.selectedTimeSeriesCat.indexOf(value) == -1) {
        tmptimeSeriesData.selectedTimeSeriesCat.push(value)
      } else {
        tmptimeSeriesData.selectedTimeSeriesCat.splice(tmptimeSeriesData.selectedTimeSeriesCat.indexOf(value), 1)
      }
    }
    settimeSeriesData(tmptimeSeriesData);
  };

  const selecttopicSentiment = (e, value, isTime) => {
    let tmptimeSeriesData = { ...timeSeriesData };
    if (isTime) {
      tmptimeSeriesData.selectedTimeSeriesTime = value
    }
    else {
      if (tmptimeSeriesData.selectedTimeSeriesCat.indexOf(value) == -1) {
        tmptimeSeriesData.selectedTimeSeriesCat.push(value)
      } else {
        tmptimeSeriesData.selectedTimeSeriesCat.splice(tmptimeSeriesData.selectedTimeSeriesCat.indexOf(value), 1)
      }
    }
    settimeSeriesData(tmptimeSeriesData);
  };

  const filterTimeSeries = (e) => {
    setfilterBox(false);
    let tmpSeriesData = []
    timeSeriesData.originalData.forEach(ele => {
      if (timeSeriesData.selectedTimeSeriesCat.indexOf(ele.label) != -1) {
        tmpSeriesData.push({ name: ele.label, data: ele.data[timeSeriesData.selectedTimeSeriesTime].values })
      }
    })
    settimeSeriesData((prev) => ({
      ...timeSeriesData,
      chartSeries: tmpSeriesData,
      labels: timeSeriesData.originalData.length == 0 ? [] : timeSeriesData.originalData[0].data[timeSeriesData.selectedTimeSeriesTime].timestamp,
    }));
  };



  const selectCatDemographyAndReg = (e, value, selectedCatFor) => {
    e.stopPropagation();
    if (selectedCatFor == "Demography") {
      let tmpdemographicsResult = { ...demographicsResult };
      tmpdemographicsResult.selectedCat = value
      setdemographicsResult(tmpdemographicsResult);
    } else if (selectedCatFor == "Regression") {
      let tmpdemographicsResult = { ...companyTrustMatrix };
      tmpdemographicsResult.selectedCat = value
      setCompanyTrustMatrix(tmpdemographicsResult);
    } else if (selectedCatFor == "Churn") {
      let tmpchurnRateResult = { ...churnRate };
      tmpchurnRateResult.selectedChurnCat = value
      setChurnRate(tmpchurnRateResult);
    }
  };

  const filterDemographyAndReg = (selectedCatFor) => {
    setfilterBox(false);
    if (selectedCatFor == "Demography") {
      let listOfCategoryData = demographicsResult.chartData[demographicsResult.selectedCat];
      setdemographicsResult((prev) => ({
        ...demographicsResult,
        chartSeries: listOfCategoryData.series,
        labels: listOfCategoryData.labels,
      }));
    } else if (selectedCatFor == "Churn") {
      let withoutoverAllChurnData = { ...churnRate.originalData };
      let selectedChartData1 = { ...withoutoverAllChurnData };
      let selectedChartData = selectedChartData1[churnRate.selectedChurnCat];
      let chartData = selectedChartData.labels.map((ele, ind) => ({ text: ele, value: selectedChartData.data[ind], color: (selectedChartData.color == undefined ? "#000" : selectedChartData.color[ind]), responseIds: (selectedChartData.response_id == undefined ? [] : selectedChartData.response_id[ind]) }))
      let chartData1 = (chartData.sort((a, b) => parseFloat(b.value) - parseFloat(a.value))).slice(0, 20);

      setChurnRate((prev) => ({
        ...churnRate,
        chartSeries: chartData1,
      }));
    } else if (selectedCatFor == "Regression") {
      let selectedChartData1 = { ...companyTrustMatrix.originalData };
      let selectedChartData = selectedChartData1[companyTrustMatrix.selectedCat];
      const cloneselectedChartData = (({ overall, ...o }) => o)(selectedChartData);
      let newAllTrustLable = Object.keys(cloneselectedChartData);
      let newAllTrustValue = Object.values(cloneselectedChartData);
      setCompanyTrustMatrix((prev) => ({
        ...companyTrustMatrix,
        chartSeries: [{
          name: selectedChartData.overall.label,
          data: newAllTrustValue,
        }],
        labels: newAllTrustLable,
        overall: selectedChartData.overall.value + "%",
        selectedCat: companyTrustMatrix.selectedCat
      }));
    }

    else if ('Sentiment By Topic') {
      let filtertopicSentimentResult1 = topicSentimentResult;
      let filtersetSelected = selected;
      let filterset = []
      filtersetSelected.forEach(ele => {
        const value = filtertopicSentimentResult1.filter(p => p.topic == ele)
        if (value.length > 0) {
          filterset.push(value[0])
        }
      })
      settopicSentimentResult1(filterset)
      console.log(filterset)
    }

  };

  const weekStart = new Date(new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 7) % 7)).toDateString());
  const weekEnd = new Date(new Date(new Date().setDate(new Date(new Date().setDate((new Date().getDate()
    - (new Date().getDay() + 7) % 7))).getDate() + 6)).toDateString());

  const lastweekStart = new Date(new Date(new Date().setDate(new Date(new Date().setDate((new Date().getDate()
    - (new Date().getDay() + 7) % 7))).getDate() - 7)).toDateString());
  const lastweekEnd = new Date(new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 8) % 7)).toDateString());

  const monthStart = new Date(new Date(new Date().setDate(1)).toDateString());
  const monthEnd = new Date(new Date(new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0)).toDateString());
  const lastStart = new Date(new Date(new Date(new Date().setMonth(new Date().getMonth() - 1)).setDate(1)).toDateString());
  const lastEnd = new Date(new Date(new Date().setDate(0)).toDateString());
  const yearStart = new Date(new Date(new Date().getFullYear() - 1, 0, 1).toDateString());
  const yearEnd = new Date(new Date(new Date().getFullYear() - 1, 11, 31).toDateString());


  useEffect(() => {
    fetchSurveyResult();

    if (resultData.mapping_json != undefined) {
      let surveyList = (JSON.parse(resultData.mapping_json));
      let tmpSurveyList = surveyList.filter((ele1) => ele1.dataType == "Typeform").map((el) => el.survey);
      let hubspotConnectedListFeedback = surveyList.filter((ele) => ele.dataType == "Hubspot" && ele.hs_object === "feedback").map((el) => el.survey);
      let newOptionList = tmpSurveyList.length == 0 ? hubspotConnectedListFeedback : tmpSurveyList
      setoptionSurveyListForFilter(newOptionList);
      let newListSelectedSurvey = { form_ids: (tmpSurveyList.length == 0 ? hubspotConnectedListFeedback.map(ele => ele.label) : tmpSurveyList.map(ele => ele.label)) }
      let getSelectedSurveyList = { form_ids: (resultData.analysis_name == undefined || resultData.analysis_name.length == 0 ? newListSelectedSurvey.form_ids : resultData.analysis_name) }
      setselectedSurveyListForFilter(getSelectedSurveyList);
    }
  }, []);

  useEffect(() => {
    if (isFilteredChurn != "") {
      getFilteredResult(" WHERE churn_risk = " + "'" + isFilteredChurn + "'");
    }
  }, [isFilteredChurn]);

  useEffect(async () => {
    if (showLoderSegmentation) {
      intervalForSegmentationFilter.current = setInterval(() => {
        checkedSegmentsFilterStatusMongo();
      }, 3000);
    } else {
      clearInterval(intervalForSegmentationFilter.current);
    }
  }, [showLoderSegmentation]);


  const checkedSegmentsFilterStatusMongo = async () => {
    fetch(`${process.env.REACT_APP_API_URL}/survey/viewResult`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        project_name: resultData.project_name,
        user_id: resultData.user_id,
        template: resultData.template,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("resultttoooooooooo", res);
        if (res.success === true && res.data.length != 0) {
          let mappingCrossTab1 = res.data[res.data.length - 1].cross_tab;
          let mappingCrossTab = (typeof mappingCrossTab1 == "string") ? JSON.parse(mappingCrossTab1) : mappingCrossTab1;
          let crossTabStatus = res.data[res.data.length - 1].cross_tab_status;
          // let findInprogressIngestionerror = response1.data.data.filter((ele) => ele.message != "");

          setLoaderShowSegmentation(crossTabStatus == "completed" ? false : true);
          if (crossTabStatus == "completed") {
            setMappingCrossTabQuestion(mappingCrossTab.crosstab);
            let tmpMappingObj = {}
            mappingCrossTab.mapping_list.forEach(ele => {
              tmpMappingObj[ele.tab_name] = ele.ques;
            })
            setMappingListCrossTab(tmpMappingObj);
            let tmpsegmentationCategoryMapping = mappingCrossTab.mapping_list;
            tmpsegmentationCategoryMapping.push({ ques: 'Overall Response', tab_name: 'Overall Response' })
            setsegmentationCategoryMapping(tmpsegmentationCategoryMapping);
            setIsCreateOpenSegmentation(false)

            /*---------- excel download ---------- */
            let exlheader = tmpsegmentationCategoryMapping.map((item, ind1) => {
              return item.ques.split("\n")[0]
            })
            exlheader.unshift('');
            setexcelHeader(exlheader)

            let newdata = []
            mappingCrossTab.crosstab.forEach((item, ind2) => {
              newdata.push(item.tableHeader.map((itemn1, ii) => (itemn1.split("\n").length == 1 ? itemn1 : itemn1.split("\n")[1])))

              item.tableRow.forEach((item1, i) => {
                newdata.push(item1)
              })
            })
            setexcelRowData(newdata)
            /*---------- excel download ---------- */

            // }
            // else {
            //   setisRunningIngestion(false)
            // let errorListitem = findInprogressIngestionerror.map((ele) => ({ ...ele, short_text: 'Filter Error', message: (ele.message.split(/[,|;]+/)), alertType: 'error-message', isCollapsable: true }));
            // seterrorListDisplay(errorListitem);
            // let tmpwithouterror = selected.filter((elem) => elem.label != "Typeform")
            // let tmpremoveprogress = checkProgressDatasetStatus.filter((elem) => elem.dataSource != "typeform");
            // setcheckProgressDatasetStatus(tmpremoveprogress)
            // setSelected(tmpwithouterror);
          }


        }
      }).catch((err) => {
        console.log("Error: " + err);
      });;


  };

  /* ------------------------ drag and drop   ------------------------ */
  const data = [
    {
      id: "1",
      name: "Praesent.",
    },
    {
      id: "2",
      name: "Fix Styling",
    },
    {
      id: "3",
      name: "Handle Door Specs",
    },
    {
      id: "4",
      name: "morbi",
    },
    {
      id: "5",
      name: "proin",
    },
  ];

  const columnsFromBackend = {
    'abcd': {
      title: "To-do",
      items: [{
        id: "1",
        name: "Praesent.",
      },
      {
        id: "2",
        name: "a Styling",
      },],
    },
    'acd': {
      title: "In Progress",
      items: [{
        id: "1",
        name: "Praesent.",
      },],
    },

  };

  const [columns, setColumns] = useState(
    {
      //    "0": {
      //         "items": [
      //             {
      //                 "id": "00",
      //                 "name": "consumer",
      //                 "qus": "Are you a consumer or professional user?"
      //             },
      //             {
      //                 "id": "11",
      //                 "name": "professional",
      //                 "qus": "Are you a consumer or professional user?"
      //             }
      //         ]
      //     },
      //     "1": {
      //         "items": [
      //             {
      //                 "id": "22",
      //                 "name": "Online",
      //                 "qus": "From where would you most likely purchase products?"
      //             },
      //             {
      //                 "id": "33",
      //                 "name": "Offline",
      //                 "qus": "From where would you most likely purchase products?"
      //             }
      //         ]
      //     },
      //     "2": {
      //         "items": [
      //             {
      //                 "id": "44",
      //                 "name": "Yes",
      //                 "qus": "Have you purchased from the brand in the last 12 months?"
      //             }
      //         ]
      //     },
      //     "3": {
      //         "items": [
      //             {
      //                 "id": "55",
      //                 "name": "1",
      //                 "qus": "How likely are you to recommend us to a friend or colleague?"
      //             },
      //             {
      //                 "id": "66",
      //                 "name": "3",
      //                 "qus": "How likely are you to recommend us to a friend or colleague?"
      //             }
      //         ]
      //     }  
      // "0": {
      //     "items": [
      //         {
      //             "id": "11",
      //             "name": "consumer",
      //             "qus": "Are you a consumer or professional user?"
      //         },
      //         {
      //             "id": "22",
      //             "name": "professional",
      //             "qus": "Are you a consumer or professional user?"
      //         }
      //     ]
      // },
      // "1": {
      //     "items": [
      //         {
      //             "id": "33",
      //             "name": "Online",
      //             "qus": "From where would you most likely purchase products?"
      //         },
      //         {
      //             "id": "44",
      //             "name": "Offline",
      //             "qus": "From where would you most likely purchase products?"
      //         }
      //     ]
      // },
      // "2": {
      //     "items": [
      //         {
      //             "id": "55",
      //             "name": "Yes",
      //             "qus": "Have you purchased from the brand in the last 12 months?"
      //         }
      //     ]
      // },
      // "3": {
      //     "items": [
      //         {
      //             "id": "66",
      //             "name": "1",
      //             "qus": "How likely are you to recommend us to a friend or colleague?"
      //         },
      //         {
      //             "id": "77",
      //             "name": "5",
      //             "qus": "How likely are you to recommend us to a friend or colleague?"
      //         }
      //     ]
      // },

      // "4": {
      //     "items": [
      //         {
      //             "id": "0",
      //             "name": "Strongly Agree",
      //             "qus": "I feel I know a lot about the brand"
      //         },
      //         {
      //             "id": "1",
      //             "name": "Disagree",
      //             "qus": "I feel I know a lot about the brand"
      //         }
      //     ]
      // },
      // "5": {
      //     "items": [
      //         {
      //             "id": "0",
      //             "name": "Agree",
      //             "qus": "I frequently see or hear about this brand in the media, online, or in advertising"
      //         },
      //         {
      //             "id": "1",
      //             "name": "Disagree",
      //             "qus": "I frequently see or hear about this brand in the media, online, or in advertising"
      //         }
      //     ]
      // },
      // "6": {
      //     "items": [
      //         {
      //             "id": "0",
      //             "name": "Agree",
      //             "qus": "I like this brand"
      //         }
      //     ]
      // },
      // "7": {
      //     "items": [
      //         {
      //             "id": "0",
      //             "name": "Agree",
      //             "qus": "I trust this brand"
      //         }
      //     ]
      // }
    });
  const onDragEnd = (result, columns, setColumns) => {
    if (!result.destination) return;
    const { source, destination } = result;
    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId];
      const destColumn = columns[destination.droppableId];
      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      let aa = {
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      }
      if (sourceItems.length == 0) {
        delete aa[source.droppableId];
      }
      setColumns(aa);
    } else {
      const column = columns[source.droppableId];
      const copiedItems = [...column.items];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      });
    }
  };
  /* ------------------------ drag and drop   ------------------------ */

  const [excelHeader, setexcelHeader] = useState([]);
  const [excelRowData, setexcelRowData] = useState([]);


  return (
    <div className="section-green result-pages">
      <div className="float-right">
        {/* {
          generativeInsights != "" && generativeInsights != "null" && */}
        <Button
          sx={{ mb: 1, mr: 1, }}
          size="small"
          color="primary"
          variant="outlined"
          onClick={(e) => openInsightDialogBox(e, "Dashboard")}
        >
          <img src={InsightIcons} alt="Insight" className="mr-2" />
          Insight
        </Button>
        {/* } */}
        {
          mappingCrossTabQuestion.length != 0 &&
          <Button
            sx={{ mb: 1, mr: 1, }}
            size="small"
            color="primary"
            variant="outlined"
            onClick={(e) => openSegmentaionDialogBox(e, "Dashboard")}
          >
            <img src={SegmentationIcons} alt="Insight" className="mr-2" />
            Segmentation
          </Button>
        }

        <Button
          sx={{ mb: 1 }}
          size="small"
          color="primary"
          variant="outlined"
          onClick={(e) => openFilterBox(e, "Dashboard")}
        >
          {" "}
          <i className="fa fa-filter mr-2"></i>
          {" "}
          Filter{" "}
        </Button>
        <Button
          sx={{ mb: 1 }}
          size="small"
          color="primary"
          variant="outlined"
          disabled={positiveSatisfactionResult.filterdRow.length == 0}
          onClick={(e) => hideDataTable(e)}
          className="ml-2"
        >
          <i
            className={dataTable ? "fa fa-indent mr-2" : "fa fa-dedent  mr-2"}
          ></i>{" "}
          Table{" "}
        </Button>
      </div>
      <div className="clearfix"></div>

      {/* ------------filter box ------------ */}
      <Popover
        open={filterBox}
        close={(e) => closeFilterBox()}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }} style={{ "left": filterPopup.xPosition, "top": filterPopup.yPosition, }}
      >
        <div className="filterBox">

          <a onClick={(e) => closeFilterBox()} className='fa fa-close float-right'></a> <h4 className="m-0"><i className="fa fa-filter"> </i> Filter {filterForBoxString == "Churn" ? "Word Cloud" : filterForBoxString}</h4>
          {filterForBoxString == "Time Series" ? (
            <><label>Category</label>
              <FormControl sx={{ mt: 0.5, mb: 1, minWidth: "100%", maxWidth: "100%" }}>
                <Select labelId="survey-filter" id="survey-filter" multiple value={timeSeriesData.selectedTimeSeriesCat} onChange={handleChange} renderValue={(selected) => selected.join(',')}
                >
                  {timeSeriesData.originalData.map((item, i) => (
                    <MenuItem key={item.label} value={item.label} onClick={(e) => { selectCatTimeSeries(e, item.label, false) }}>
                      <Checkbox checked={timeSeriesData.selectedTimeSeriesCat.indexOf(item.label) == -1 ? false : true} />
                      <ListItemText primary={item.label} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <label>Time Frame</label>
              <FormControl sx={{ mt: 0.5, mb: 2, minWidth: "100%" }}>
                <Select labelId="time-frame" id="time-frame" value={timeSeriesData.selectedTimeSeriesTime} >
                  {timeSeriesData.selectedTimeSeriesTimeOption.map((item, i) => (
                    <MenuItem key={item.value} value={item.value} onClick={(e) => { selectCatTimeSeries(e, item.value, true) }}>
                      {/* <Checkbox /> */}
                      <ListItemText primary={item.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <br />
              <Button
                sx={{ mt: { xs: 2, sm: 0 } }}
                color="primary"
                variant="outlined"
                onClick={() => {
                  filterTimeSeries();
                }}
              >
                Filter
              </Button>
            </>
          )
            : filterForBoxString == "Demography" || filterForBoxString == "Regression" || filterForBoxString == "Churn" || filterForBoxString == "Sentiment By Topic" ? (
              <><label>Category</label>
                <FormControl sx={{ mt: 0.5, mb: 1, minWidth: "100%", maxWidth: "100%" }}>
                  {
                    filterForBoxString == "Demography" && (
                      <>
                        <Select labelId="survey-filter" id="survey-filter" value={demographicsResult.selectedCat} >
                          {demographicsResult.categoriesList.map((item, i) => (
                            <MenuItem key={item} value={item} onClick={(e) => { selectCatDemographyAndReg(e, item, "Demography") }}>
                              <ListItemText primary={item} />
                            </MenuItem>
                          ))}
                        </Select>
                      </>)
                  }
                  {
                    filterForBoxString == "Churn" && (
                      <>
                        <Select labelId="survey-filter" id="survey-filter" value={churnRate.selectedChurnCat} >
                          {churnRate.labels.map((item, i) => (
                            <MenuItem key={item} value={item} onClick={(e) => { selectCatDemographyAndReg(e, item, "Churn") }}>
                              <ListItemText primary={item} />
                            </MenuItem>
                          ))}
                        </Select>
                      </>)
                  }
                  {
                    filterForBoxString == "Regression" && (
                      <>
                        <Select labelId="survey-filter" id="survey-filter-reg" value={companyTrustMatrix.selectedCat} >
                          {companyTrustMatrix.categoriesList.map((item, i) => (
                            <MenuItem key={item} value={item} onClick={(e) => { selectCatDemographyAndReg(e, item, "Regression") }}>
                              <ListItemText primary={item} />
                            </MenuItem>
                          ))}
                        </Select></>)
                  }
                  {
                    filterForBoxString == "Sentiment By Topic" && (
                      <>
                        {/* <FormControl sx={{ mt: 0.5, mb: 1, minWidth: "100%", maxWidth: "100%" }}>
                    <Select labelId="survey-filter" id="survey-filter" multiple value={topicSentimentLabel} onChange={handleChange} renderValue={(selected) => selected.join(',')}
                    >
                      {topicSentimentResult1.map((item, i) => (
                        <MenuItem key={item.label} value={item.label} onClick={(e) => { selecttopicSentiment(e, item.topic, false) }}>
                          <Checkbox checked={timeSeriesData.selectedTimeSeriesCat.indexOf(item.topic) == -1 ? false : true} />
                          <ListItemText primary={item.topic} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>   */}
                        <FormControl>
                          <Select
                            labelId="mutiple-select-label"
                            multiple
                            value={selected}
                            onChange={handleChangefilter}
                            renderValue={(selected) => selected.join(", ")}
                          >
                            <MenuItem value="all">
                              <ListItemIcon>
                                <Checkbox
                                  checked={isAllSelected}
                                  indeterminate={
                                    selected.length > 0 && selected.length < topicSentimentLabel.length
                                  }
                                />
                              </ListItemIcon>
                              <ListItemText primary="Select All" />
                            </MenuItem>
                            {topicSentimentLabel.map((option) => (
                              <MenuItem key={option} value={option}>
                                <ListItemIcon>
                                  <Checkbox checked={selected.indexOf(option) > -1} />
                                </ListItemIcon>
                                <ListItemText primary={option} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </>)
                  }
                </FormControl>
                <br />
                <Button
                  sx={{ mt: { xs: 2, sm: 0 } }}
                  color="primary"
                  variant="outlined"
                  onClick={() => {
                    filterDemographyAndReg(filterForBoxString);
                  }}
                >
                  Filter
                </Button></>) : (
              <>
                <label>Survey Filter</label>
                {/* <FormControl sx={{ mt: 1.5, mb: 2, minWidth: "100%", maxWidth: "100%" }}>
                <InputLabel id="demo-multiple-name-label">Survey Filter</InputLabel>
                  <Select labelId="survey-filter" id="survey-filter" input={<OutlinedInput label="Survey Filter" />} multiple value={selectedSurveyListForFilter.form_ids} onChange={handleChange} renderValue={(selected) => selected.join(',')}
                  >
                      {optionSurveyListForFilter.map((item, i) => (
                      <MenuItem key={item.label} value={item.value} onClick={(e) => { selectSurveyForGlobalFilter(e, item.value, false) }}>
                        <Checkbox checked={selectedSurveyListForFilter.form_ids.indexOf(item.value) != -1} />
                        <ListItemText primary={item.label} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}

                <FormControl sx={{ mt: 1.2, mb: 1, minWidth: "100%", maxWidth: "100%" }}>
                  {/* <InputLabel id="survey-filter1">Survey Filter</InputLabel> */}
                  {/* label="Survey Filter" */}
                  <Select labelId="survey-filter1" id="survey-filter111" multiple value={selectedSurveyListForFilter.form_ids} renderValue={(selected) => selected.join(',')}
                  >
                    {optionSurveyListForFilter.map((item, i) => (
                      <MenuItem key={item.label} value={item.value} onClick={(e) => { selectSurveyForGlobalFilter(e, item.label, false) }}>
                        <Checkbox checked={selectedSurveyListForFilter.form_ids.indexOf(item.label) != -1} />
                        <ListItemText primary={item.label} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <br />
                <label  >Time Frame</label>
                <br />
                <Box sx={{ mt: 2 }}>
                  <DateRangePickerComponent placeholder='Select Time range' cssClass="e-outline" change={(ev) => { setfilterDateRange(ev.value) }}>
                    <PresetsDirective>

                      <PresetDirective label="Current Week" start={weekStart} end={weekEnd}></PresetDirective>
                      <PresetDirective label="Last Week" start={lastweekStart} end={lastweekEnd}></PresetDirective>
                      <PresetDirective label="Current Month" start={monthStart} end={monthEnd}></PresetDirective>
                      <PresetDirective label="Last Month" start={lastStart} end={lastEnd}></PresetDirective>
                      <PresetDirective label="Last Year" start={yearStart} end={yearEnd}></PresetDirective>
                    </PresetsDirective>
                  </DateRangePickerComponent>

                </Box>
                <br />
                {/* || filterDateRange[0] == null || filterDateRange[1] == null */}
                <Button
                  disabled={showLoderVisual || selectedSurveyListForFilter.form_ids.length == 0}
                  sx={{ mt: { xs: 2, sm: 0 } }}
                  color="primary"
                  variant="outlined"
                  onClick={() => {
                    filterGlobalFilterOk();
                  }}
                >
                  Filter
                </Button>
                {
                  errorFilterBox.show && (
                    // <span className="error-text"></span>
                    <p className="error-text">{errorFilterBox.message}</p>
                  )
                }
                {showLoderVisual && (
                  <Box sx={{ textAlign: "center" }}>
                    <CircularProgress />
                  </Box>
                )}
              </>
            )
          }
        </div>
      </Popover>

      <Popover
        open={openSegmentation}
        close={(e) => closeSegmentaionDialogBox()}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        style={{ "left": 0, "top": filterPopup.yPosition, overflow: iscreateOverflow, width: '100%' }}
        segmentation
      >
        <div className="p-3">
          <Button
            sx={{ mb: 1 }}
            size="small"
            color="primary"
            variant="contained"
            onClick={(e) => setIsCreateOpenSegmentation(true)}
          >
            <i className="fa fa-plus mr-2"></i>
            Create Segmentation
            <span  className="add-edit-btn"></span>
          </Button>

          {
            isCreateOpenSegmentation &&
            <div style={{ position: 'absolute', left: 15, width: '50%', height: '50vh', zIndex: 2 }}>
              <Card>
                <Button
                  size="small"
                  color="primary"
                  variant="outlined"
                  className="float-right"
                  style={{ margin: '5px', }}
                  onClick={(e) => setIsCreateOpenSegmentation(false)}
                >
                  <i className="fa fa-close mr-2"></i>
                  Close
                </Button>
                <CardHeader title={"All Survey Question"}>
                </CardHeader>
                <CardContent>
                  <div className="segmentionlist">
                    <div>
                      {mappingCrossTabQuestion.map((item, i) =>
                      (
                        <>
                          {
                            item.tableHeader.map((itemHeader, ii) => (
                              <>
                                {ii == 0 &&
                                  <Accordion className="accodion-style">
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls={"panel" + i + "-content"}
                                      id={"panel" + i + "-header"}
                                    >
                                      {i + 1}. {itemHeader}
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {
                                        item.tableRow.map((itemBody, ind1) => (
                                          <>
                                            {
                                              itemBody.map((itemBodydata, iii) => (
                                                <>
                                                  {
                                                    iii == 0 &&
                                                    <div className="checkbox-list"><Checkbox checked={checkedSelectedSegmentation(itemHeader, itemBodydata)} onChange={(event) => { handleSelectSegmentOption(event.target.checked, itemHeader, itemBodydata) }} /> {itemBodydata}</div>
                                                  }
                                                </>
                                              ))
                                            }
                                          </>
                                        ))
                                      }

                                    </AccordionDetails>
                                  </Accordion>
                                }
                              </>
                            ))
                          }
                        </>
                      ))}</div>

                  </div>
                  <div className="selectedSegmention"  >
                    <div className="heading">
                      Selected Segmentation - Drag and Drop to Combine
                      <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        className="float-right"
                        // disabled={Object.keys(selectedSegmentationOption).length <= 0}
                        style={{ margin: '-5px -2px', float: 'right', color: '#fff', cursor: 'pointer' }}
                        onClick={(e) => {
                          resetSegmentation()
                        }}
                      >
                        Reset
                      </Button>
                    </div>
                    <div className="list-scroll">
                      <DragDropContext onDragEnd={(result) => onDragEnd(result, columns, setColumns)}>
                        <section style={{ display: "flex", padding: '0px' }}>
                          <div style={{ width: "100%" }}>
                            {Object.entries(columns).map(([columnId, column], index) => {
                              return (
                                <Droppable key={columnId} droppableId={columnId}>
                                  {(provided, snapshot) => (
                                    <div className="taskList"
                                      ref={provided.innerRef}
                                      {...provided.droppableProps}
                                    >
                                      <div className="dragchipsul">
                                        {column.items.map((item, index) => (
                                          <Draggable
                                            key={item.id}
                                            draggableId={item.id}
                                            index={index}
                                          >
                                            {(provided) => (
                                              <span className="dragchips"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                              >
                                                <div className="dragchipslabel" title={item.qus}>
                                                  {item.name}
                                                </div>
                                              </span>
                                            )}
                                          </Draggable>
                                        ))}</div>
                                      {provided.placeholder}
                                    </div>
                                  )}
                                </Droppable>
                              );
                            })}
                          </div>
                        </section>
                      </DragDropContext>
                    </div>
                  </div>
                </CardContent>
                <Button disabled={true}>{((Object.values(columns).map(ele => ele.items)).flat()).length} selected</Button>

                {showLoderSegmentation ? <>  <CircularProgress size="1.5rem" className="float-right m-2" /> </> : <> <Button
                  size="small"
                  color="primary"
                  variant="contained"
                  className="float-right"
                  // disabled={Object.keys(selectedSegmentationOption).length <= 0}
                  style={{ margin: '5px', }}
                  onClick={(e) => handleubmitSegmentOptionFilter()}
                >
                  Save
                </Button> </>}

              </Card>
            </div>
          }


          <Button
            size="small"
            color="primary"
            variant="outlined"
            className="float-right"
            onClick={(e) => closeSegmentaionDialogBox()}
          >  <i className="fa fa-close mr-2"></i> Close </Button>
          {/*---------- Don't delete */}
           <Button sx={{ mb: 1 }}
            size="small"  className="float-right mr-2"
            color="primary"
            variant="outlined"
          ><CSVLink filename={"survey-question-reports.csv"} 
  target="_blank" rel="noopener noreferrer" data={excelRowData} headers={excelHeader}><i className="fa fa-file-excel-o"></i> &nbsp; Download Segmentation</CSVLink></Button>  
          <div style={{ width: "100%", height: "70vh", overflow: 'auto' }} >
            {mappingCrossTabQuestion.map((item, ind2) => (
              <>
                <table align='left' width={'100%'} className="segmentation-table" cellspacing='0' cellpadding='0' >

                  <tr className="table-head">
                    {
                      ind2 == 0 &&
                      segmentationCategoryMapping.map((tableTopHeader, catInd) => (
                        <>
                          {
                            catInd == 0 &&
                            <th></th>
                          }
                          <th style={{ textAlign: "center", background: '#0355F9', borderRight: ' #fff solid 2px', color: '#ffffff', position:'relative' }}>{tableTopHeader.tab_name != "Overall Response"?<span onClick={(event) => { handleDeleteSegmentOption(event, tableTopHeader,catInd) }} className=" small-close-td small-close-btn"></span>:''}<div className="customtooltip"> {tableTopHeader.tab_name.split("\n")[0]} 
                            <span class="tooltiptext">{tableTopHeader.ques}</span>
                          </div> <div></div></th>
                        </>
                      ))
                    }

                  </tr>

                  <tbody>
                    <tr className="table-head">
                      {
                        item.tableHeader.map((itemHeader, i) => (
                          <th width={i != 0 ? 250 : 'auto'} style={{ "text-align": i == 0 ? `left` : "center" }}> {i == 0 ? `${ind2 + 1}.` : ""} <div className="customtooltip"> <b>{i != 0 && itemHeader != "Respondent" ? itemHeader.split("\n")[1] : itemHeader}</b>
                            {(i != 0 && itemHeader != "Respondent" ? (mappingListCrossTab[itemHeader] != undefined && mappingListCrossTab[itemHeader].length <= 0 ? <span class="tooltiptext">{i != 0 && itemHeader != "Respondent" ? mappingListCrossTab[itemHeader] : ""}</span> : '') : "")}
                          </div></th>
                        ))
                      }
                    </tr>
                    {
                      item.tableRow.map((itemBody, iii) => (
                        <tr>
                          {
                            itemBody.map((itemBodydata, ii) => (
                              <td width={ii != 0 ? 250 : 550} style={{ "text-align": ii == 0 ? `left` : "center", }}><div style={{ "width": ii == 0 ? 450 : '100%', "text-align": ii == 0 ? `left` : "center", }}>{itemBodydata}</div></td>
                            ))
                          }
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </>
            ))}
          </div>
        </div>

      </Popover >

      <Popover
        open={openInsight}
        close={(e) => closeInsightDialogBox()}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        style={{ "left": filterPopup.xPosition, "top": filterPopup.yPosition, overflow: "scroll" }}>
        <div className="p-3">
          <h2 className="float-left m-0"><img src="/json-media/img/convertmlLogoicon.png" alt='convertml'  width={40} className="float-left mr-2" />Dashboard Insight</h2>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            className="float-right"
            onClick={(e) => closeInsightDialogBox()}
          >
            <i className="fa fa-close mr-2"></i>
            Close
          </Button><div className="cleafix"></div><br />
          <h4 className="text-grey">Some Key takeaways fron this dashboard insights</h4>
          {/* <div style={{ width: "100%", height: "70vh", overflow: 'auto' }} ></div> */}
          <div className="filterBox" style={{ width: "100%", height: "70vh", overflow: 'auto' }} dangerouslySetInnerHTML={{
            __html: (generativeInsights == "" || generativeInsights == "null" ? "Data insights is being generated, Try again in sometime to view the results" : generativeInsights)
          }} />
        </div>
      </Popover>







      {/* ------------filter box ------------ */}

      <div className="splitter-container">
        <SplitterLayout
          primaryIndex={1}
          secondaryInitialSize={65}
          percentage
          primaryMinSize={20}
          secondaryMinSize={50}
        >
          <div>
            <Box sx={{ height: "63vh", width: "100%" }}>
              <div
                className={
                  kpiResult.length > 5
                    ? "total-countlistNps"
                    : "total-countlist"
                }
              >
                {kpiResult.map((item, i) => (
                  <div className="custom-card" key={i}>
                    {item.label == "total_contacts" && (
                      <>
                        <CardContent className="cardContent">
                          <span className="capitalize float-left small-text mr-1" title={item.displayName}>
                            {item.displayName}
                          </span>
                          <Tooltip
                            title={
                              "Count of unique Email IDs ingested from Hubspots."
                            }
                          >
                            <i className="fa fa-info-circle icon-size float-left"></i>
                          </Tooltip>
                          <br /> <img src={total_contacts} alt='convertml' />
                          <span className="count-number" title={item.count}> {item.count} </span>
                        </CardContent>
                      </>
                    )}
                    {item.label == "total_responded" && (
                      <>
                        <CardContent className="cardContent">
                          <span className="capitalize small-text mr-1 float-left" title={item.displayName}>
                            {item.displayName}
                          </span>
                          <Tooltip
                            title={
                              "Count of unique responses ingested from Typeform surveys."
                            }
                          >
                            <i className="fa fa-info-circle icon-size float-left"></i>
                          </Tooltip>
                          <br />
                          <img src={totalResponded} alt='convertml' />
                          <span className="count-number" title={item.count} > {item.count} </span>
                        </CardContent>
                      </>
                    )}
                    {item.label == "response_percent" && (
                      <>
                        <CardContent className="cardContent">
                          <span className="capitalize small-text float-left  mr-1" title={item.displayName}>
                            {item.displayName}
                          </span>
                          <Tooltip
                            title={
                              "Response percentage indicates the proportion of participants who answered a particular question or expressed a specific sentiment, relative to the total number of respondents."
                            }
                          >
                            <i className="fa fa-info-circle float-left icon-size"></i>
                          </Tooltip>
                          <br />
                          <img src={totalResponsePercent} alt='convertml' />
                          <span className="count-number" title={item.count + '%'}> {item.count}% </span>
                        </CardContent>
                      </>
                    )}
                    {(item.label == "overall_sentiment" ||
                      item.label == "cltv") && (
                        <>
                          <CardContent className="cardContent">
                            <span className="capitalize small-text float-left mr-1" title={item.displayName == "cltv"
                              ? "CLTV"
                              : item.displayName}>
                              {item.displayName == "cltv"
                                ? "CLTV"
                                : item.displayName}
                            </span>
                            <Tooltip
                              title={
                                item.displayName == "cltv"
                                  ? "Customer Lifetime Value (CLV) is a metric that calculates the total expected revenue a business can generate from a customer throughout their entire relationship. It helps businesses assess the long-term profitability of acquiring and retaining customers, guiding strategic decisions for marketing and customer engagement."
                                  : "An aggregated score ranging from 0-1 indicating the overall sentiment based over all the sentiment related questions."
                              }
                            >
                              <i className="fa fa-info-circle float-left icon-size"></i>
                            </Tooltip>
                            <br />
                            <img src={cltv} alt='convertml' />
                            <span className="count-number" title={item.count} > {item.count} </span>
                          </CardContent>
                        </>
                      )}
                    {item.label == "nps" && (
                      <>
                        <CardContent className="cardContent">
                          <span className="capitalize small-text float-left mr-1" title={item.displayName.toUpperCase()}>
                            {item.displayName.toUpperCase()}
                          </span>
                          <Tooltip
                            title={
                              "Net Promoter Score (NPS) is a customer satisfaction metric that quantifies the willingness of customers to recommend a product, service, or brand to others."
                            }
                          >
                            <i className="fa fa-info-circle float-left icon-size"></i>
                          </Tooltip>
                          <br />
                          <img src={nps} alt='convertml' />
                          <span className="count-number" title={item.count + '100'}>{item.count}/100</span>
                        </CardContent>
                      </>
                    )}
                  </div>
                ))}
              </div>
              {
                resultData.template != "Market Research" &&
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <Card
                      className={
                        (selectedGridBox == ` WHERE sat_category = 'positive'` || selectedGridBox == ` WHERE sat_category = 'Promoter'`)
                          ? "cardBox selectCard"
                          : "cardBox "
                      }
                    >
                      <CardContent
                      // onClick={() => {
                      //   resultData.template == "Net Promoter Score"
                      //     ? getFilteredResult(
                      //       "WHERE nps_category = 'Promoter'"
                      //     )
                      //     : 
                      //     getFilteredResult(
                      //       "WHERE sat_category = 'positive'"
                      //     );
                      // }}
                      >
                        <img
                          src={positivechart}
                          alt="Positive"
                          className="float-right"
                        />
                        <div className="float-left" style={{ width: '145px' }}>
                          <img
                            src={positiveIcons}
                            width={30}
                            alt="Positive"
                            className="float-left"
                            style={{ marginTop: "-5px" }}
                          />{" "}
                          &nbsp;
                          <b>
                            {resultData.template == "Net Promoter Score"
                              ? "Promoter"
                              : "Positive"}
                          </b>&nbsp;<Tooltip
                            title={
                              "Highly satisfied respondents express contentment and positive sentiment towards their overall experience."
                            }
                          >
                            <i className="fa fa-info-circle icon-size"></i>
                          </Tooltip>
                          <div className="clearfix"></div>
                          <div className="count-number">
                            {satisfactionResult?.positive}%
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card
                      className={
                        (selectedGridBox == ` WHERE sat_category = 'neutral'` || selectedGridBox == ` WHERE sat_category = 'Passive'`)
                          ? "cardBox selectCard"
                          : "cardBox"
                      }
                    >
                      <CardContent
                      // onClick={() => {
                      //   resultData.template == "Net Promoter Score"
                      //     ? getFilteredResult(" WHERE nps_category = 'Passive'")
                      //     : getFilteredResult(
                      //       " WHERE sat_category = 'neutral'"
                      //     );
                      // }}
                      >
                        <img
                          src={neutralchart}
                          alt="Positive"
                          className="float-right"
                        />
                        <div className="float-left" style={{ width: '145px' }}>
                          <img
                            src={neutralIcons}
                            width={30}
                            alt="Neutral"
                            className="float-left"
                            style={{ marginTop: "-5px" }}
                          />{" "}
                          &nbsp;
                          <b>
                            {resultData.template == "Net Promoter Score"
                              ? "Passive"
                              : "Neutral"}
                          </b> <Tooltip
                            title={
                              "Moderate contentment with the overall experience, neither exceptionally pleased nor dissatisfied."
                            }
                          >
                            <i className="fa fa-info-circle icon-size"></i>
                          </Tooltip>
                          <div className="clearfix"></div>
                          <div className="count-number">
                            {satisfactionResult?.neutral}%
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    {/* {(data.row.sat_category != undefined &&
              data.row.sat_category.toLowerCase() == "negative") ||
              (data.row.sat_category != undefined &&
                data.row.sat_category.toLowerCase() == "detractor") ? */}
                    <Card
                      className={
                        (selectedGridBox == ` WHERE sat_category = 'negative'` || selectedGridBox == ` WHERE sat_category = 'Detractor'`)
                          ? "cardBox selectCard"
                          : "cardBox"
                      }
                    // onClick={() => {
                    //   resultData.template == "Net Promoter Score"
                    //     ? getFilteredResult(" WHERE nps_category = 'Detractor'")
                    //     : getFilteredResult(" WHERE sat_category = 'negative'");
                    // }}
                    >
                      <CardContent>
                        <img
                          src={negativechart}
                          alt="Positive"
                          className="float-right"
                        />
                        <div className="float-left" style={{ width: '145px' }}>
                          <img
                            src={negativeIcons}
                            width={30}
                            alt="Negative"
                            className="float-left"
                            style={{ marginTop: "-5px" }}
                          />&nbsp;<b>
                            {resultData.template == "Net Promoter Score"
                              ? "Detractor"
                              : "Negative"}
                          </b>&nbsp;
                          <Tooltip
                            title={
                              "Survey respondents expressed dissatisfaction with the provided service, citing various concerns and shortcomings."
                            }
                          >
                            <i className="fa fa-info-circle icon-size"></i>
                          </Tooltip>
                          <div className="clearfix"></div>
                          <div className="count-number">
                            {satisfactionResult?.negative}%
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              }
              <div style={{ height: 10 }}></div>
              <Grid container spacing={1}>
                {topicSentimentResult1.length != 0 && (

                  <Grid
                    item
                    xs={4}
                  // xs={resultData.template == "Net Promoter Score" ? 6 : 8}
                  >
                    <Card className="cardBox">
                      <CardContent>
                        <h3 title={resultData.template == "Net Promoter Score"
                          ? "Analysis based on Topic"
                          : "Sentiment By Topic"}>
                          {resultData.template == "Net Promoter Score"
                            ? "Analysis based on Topic"
                            : "Sentiment By Topic"}
                        </h3>
                        <div className="result-toolbar">
                          <Tooltip
                            title={
                              "Identify what your customers are talking about and their tone. Find out the most frequently used topics or phrases in your customer feedback. "
                            }
                          >
                            <i className="fa fa-info-circle icon-size"></i>
                          </Tooltip>
                          <a>
                            <i className="fa fa-filter" onClick={(e) => openFilterBox(e, "Sentiment By Topic")}></i>
                          </a>
                        </div>
                        <div className="clearfix"></div>
                        {/* overflowY:"scroll" */}
                        <Box
                          sx={{ height: 230, width: "100%", overflow: "auto" }}
                        >
                          <section
                            className="custom-chart"
                            style={{ height: 230 }}
                          >
                            {topicSentimentResult1.map((baritem) => (
                              <>
                                <label title={baritem.topic}>{baritem.topic}</label>
                                <div className="bars">
                                  <div
                                    className="promoter"
                                    style={{ width: baritem.positive + "%" }}
                                  >
                                    <span>{baritem.positive + "%"}</span>
                                  </div>
                                  <div
                                    className="passive"
                                    style={{ width: baritem.neutral + "%" }}
                                  >
                                    <span>{baritem.neutral + "%"}</span>
                                  </div>
                                  <div
                                    className="detractor"
                                    style={{ width: baritem.negative + "%" }}
                                  >
                                    <span>{baritem.negative + "%"}</span>
                                  </div>
                                </div>
                              </>
                            ))}
                          </section>
                          {/* <Chart
                          height={
                            topicSentimentResult.length != 0 &&
                            topicSentimentResult[0].data.length < 10
                              ? 250
                              : 520
                          }
                          options={sentimentBasedOptions}
                          series={topicSentimentResult}
                          type="bar"
                        /> */}
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>)
                }
                {resultData.template == "Net Promoter Score" ? (
                  <> {revenueARRResult.chartSeries.length != 0 ? <>   <Grid
                    item
                    xs={4}
                  >
                    <Card className="cardBox">
                      <CardContent>
                        <h3
                          style={{ letterSpacing: 0.6 }}
                          title={'Revenue ARR by Category'}
                        >
                          Revenue ARR by Category
                        </h3>
                        <div className="result-toolbar">
                          <Tooltip
                            title={
                              "Revenue ARR by category refers to the annual recurring revenue (ARR) generated by a business segmented according to Net Promoter Score (NPS) categories. The NPS categories, including Promoters (loyal customers), Detractors (unhappy customers), and Passives (neutral customers), help analyze how different customer segments contribute to the company's overall revenue. This metric provides insights into the financial impact of customer satisfaction levels."
                            }
                          ><i className="fa fa-info-circle icon-size"></i>
                          </Tooltip></div><div className="clearfix"></div>
                        <Box sx={{ height: 230, width: "100%" }}>
                          <div id="chart122a">
                            <Chart
                              height={230}
                              width={"100%"}
                              options={sentimentBasedOptionsNps}
                              series={revenueARRResult.chartSeries}
                              type="bar"
                            />
                          </div>
                        </Box>
                      </CardContent></Card>
                  </Grid></> : null}
                  </>

                ) : (<> {demographicsResult.chartSeries.length != 0 ? <>
                  <Grid item xs={4} >
                    <Card className="cardBox">
                      <CardContent>
                        <h3 title={`${demographicsResult.selectedCat}`}>{demographicsResult.selectedCat}</h3>
                        <div className="result-toolbar">
                          <Tooltip
                            title={
                              "Get granular-level insights into your customers by segmenting them by age, gender, region, and other demographic variables."
                            }
                          >
                            <i className="fa fa-info-circle icon-size"></i>
                          </Tooltip>
                          <a onClick={(e) => openFilterBox(e, "Demography")}>
                            <i className="fa fa-filter"></i>
                          </a>
                        </div><div className="clearfix"></div>
                        <Box
                          sx={{ height: 230, width: "100%", margin: "auto" }}
                        >
                          <div
                            id="chart122"
                            style={{ margin: "auto", width: "100%" }}
                          >
                            <Chart
                              height={260}
                              width={"100%"}
                              options={polarAreachartOptions}
                              series={demographicsResult.chartSeries}
                              type="donut"
                            />
                          </div>
                        </Box>
                      </CardContent></Card></Grid></> : null} </>

                )}

                {timeSeriesData.chartSeries.length != 0 ? <><Grid item xs={chartHalfTs} className={chartOne}>
                  <Card className="cardBox">
                    <CardContent>
                      <h3 title={`Time Series: ${timeSeriesData.selectedTimeSeriesTimeOption.filter(ele => ele.value == timeSeriesData.selectedTimeSeriesTime)[0].name}`}>
                        Time Series: {timeSeriesData.selectedTimeSeriesTimeOption.filter(ele => ele.value == timeSeriesData.selectedTimeSeriesTime)[0].name}
                        {/* {resultData.template == "Net Promoter Score"
                          ? "Likely to recommend per question"
                          : "Company Consideration"} 
                        : {companyConsidration.overall}*/}
                      </h3>
                      <div className="result-toolbar">
                        <Tooltip
                          title={
                            "Better understand your core variables by tracking them over time, such as by months, quarters, years, or a specific time period. "
                          }
                        >
                          <i className="fa fa-info-circle icon-size"></i>
                        </Tooltip>
                        <a
                          className={"-  " + hideButton
                          }
                          onClick={(e) => closeenlarge("companyTs")}
                        ><i className="fa fa-compress"> </i> </a>
                        <a className={"-  " + showButton}
                          onClick={(e) => chartenlarge("companyTs")}
                        ><i className="fa fa-expand"> </i></a>
                        <a>
                          <i className="fa fa-filter" onClick={(e) => openFilterBox(e, "Time Series")}></i>
                        </a>
                      </div><div className="clearfix"></div>
                      <Box sx={{ height: chartBoxHeight, width: "100%" }}>
                        <div id="chart11">
                          <Chart
                            height={chartHeight}
                            width={"100%"}
                            options={chartOptionsTimeSeries}
                            series={timeSeriesData.chartSeries}
                            type="line"
                          />
                        </div>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid></> : null}

                {companyTrustMatrix.chartSeries.length != 0 ? <> <Grid item xs={chartHalfTM} className={chartTwo}>
                  <Card className="cardBox">
                    <CardContent>
                      <h3 title={(companyTrustMatrix.chartSeries[0].name + " ") + (companyTrustMatrix.overall)}>
                        {companyTrustMatrix.chartSeries[0]?.name}:
                        {companyTrustMatrix.overall}
                      </h3>
                      <div className="result-toolbar">
                        <Tooltip
                          title={
                            "Understand how the overall customer satisfaction varies in relation to your products, customer care, and other services."
                          }
                        >
                          <i className="fa fa-info-circle icon-size"></i>
                        </Tooltip>
                        <a
                          className={
                            "- " + showButtonTM
                          }
                          onClick={(e) => chartenlarge("companyTM")}
                        ><i className="fa fa-expand"></i></a>
                        <a
                          className={
                            "- " + hideButtonTM
                          }
                          onClick={(e) => closeenlarge("companyTM")}
                        ><i className="fa fa-compress"></i></a>
                        <a onClick={(e) => openFilterBox(e, "Regression")}>
                          <i className="fa fa-filter"></i>
                        </a>


                      </div>
                      <Box sx={{ height: chartBoxHeightTM, width: "100%" }}>
                        <div id="chart12a">
                          <br />
                          <Chart
                            height={chartHeightTM}
                            width={"100%"}
                            options={chartOptions1}
                            series={companyTrustMatrix.chartSeries}
                            type="radar"
                          />
                        </div>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid></> : null}

                {timeSeriesData.chartSeries.length != 0 ? <><Grid item xs={chartHalf} className={chartOneCopy}>
                  <Card className="cardBox">
                    <CardContent>
                      <h3 title={resultData.template == "Net Promoter Score"
                        ? "Likely to recommend per question"
                        : "Company Consideration"}>
                        {resultData.template == "Net Promoter Score"
                          ? "Likely to recommend per question"
                          : "Company Consideration"}
                        : {companyConsidration.overall}
                      </h3>
                      <div className="result-toolbar">
                        <Tooltip
                          title={
                            "This metric assesses the level of interest and value attributed to different topics that a potential customer is thinking of regarding your company."
                          }
                        >
                          <i className="fa fa-info-circle icon-size"></i>
                        </Tooltip>
                        <a
                          className={
                            "- " + showButton
                          }
                          onClick={(e) => chartenlarge("companyC")}
                        ><i className="fa fa-expand"></i></a>
                        <a
                          className={
                            "- " + hideButton
                          }
                          onClick={(e) => closeenlarge("companyC")}
                        ><i className="fa fa-compress"></i></a>
                      </div>
                      <Box sx={{ height: chartBoxHeight, width: "100%" }}>
                        <div id="chart11">
                          <Chart
                            height={chartHeight}
                            width={"100%"}
                            options={chartOptionsTimeSeries}
                            series={timeSeriesData.chartSeries}
                            type="line"
                          />
                        </div>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid></> : null}
                {correspondenceAnalysis.chartSeries.length != 0 ? <><Grid item xs={chartHalfCR} className={chartThree}>
                  <Card className="cardBox">
                    <CardContent>
                      <h3 title={'Clustering Analysis' + (correspondenceAnalysis.overall)}>
                        Clustering Analysis {correspondenceAnalysis.overall}
                      </h3>
                      <div className="result-toolbar">
                        <Tooltip
                          title={
                            "Clustering analysis in market analysis involves grouping survey responses based on shared characteristics or preferences, revealing distinct customer segments for targeted marketing strategies and product offerings. This method uncovers valuable insights for tailoring marketing efforts and enhancing customer satisfaction."
                          }
                        >
                          <i className="fa fa-info-circle icon-size mr-1"></i>
                        </Tooltip>
                        <i
                          className={
                            "fa fa-expand " + showButtonCR
                          }
                          onClick={(e) => chartenlarge("companyCR")}
                        ></i>
                        <i
                          className={
                            "fa fa-compress " + hideButtonCR
                          }
                          onClick={(e) => closeenlarge("companyCR")}
                        ></i>
                      </div>
                      <div className="clearfix"></div>
                      <Box sx={{ height: chartBoxHeightCR, width: "100%" }}>
                        <div id="chart12b">
                          <Chart
                            height={chartHeightCR}
                            options={chartOptions2}
                            series={correspondenceAnalysis.chartSeries}
                            type="scatter"
                          />
                        </div>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid></> : null}

                {churnRate.chartSeries.length != 0 ? <><Grid item xs={chartHalfPC} className={chartFour}>
                  <Card className="cardBox">
                    <CardContent>
                      <h3 title={'Word Cloud: ' + churnRate.selectedChurnCat}>
                        Word Cloud: {churnRate.selectedChurnCat}
                      </h3>
                      <div className="result-toolbar">
                        <Tooltip
                          title={
                            "Word clouds visually represent the most frequently mentioned words in the customer feedback."
                          }
                        >
                          <i className="fa fa-info-circle icon-size"></i>
                        </Tooltip>
                        <a> <i
                          className={
                            "fa fa-expand " + showButtonPC
                          }
                          onClick={(e) => chartenlarge("companyPC")}
                        ></i></a>
                        <a> <i
                          className={
                            "fa fa-compress " + hideButtonPC
                          }
                          onClick={(e) => closeenlarge("companyPC")}
                        ></i> </a>
                        {
                          churnRate.chartSeries.length != 0 &&
                          <a>
                            <i className="fa fa-filter" onClick={(e) => openFilterBox(e, "Churn")}></i>
                          </a>
                        }

                      </div>
                      <Box sx={{ height: chartBoxHeightPC, width: "100%" }}> <br />
                        <ReactWordcloud
                          callbacks={callbacks}
                          options={optionsWordCloud}
                          words={churnRate.chartSeries}
                        />

                        {/* <Chart
                          id='potentialChurnRate'
                          height={chartHeightPC}
                          options={chartOptions3}
                          series={churnRate.chartSeries}
                          type="boxPlot"
                        /> */}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid></> : null}
                {correspondenceAnalysis.chartSeries.length != 0 ? <><Grid item xs={chartHalfCR} className={chartThreeCopy}>
                  <Card className="cardBox">
                    <CardContent>
                      <h3 title={'Clustering Analysis ' + (correspondenceAnalysis.overall)}>
                        Clustering Analysis {correspondenceAnalysis.overall}
                      </h3>
                      <div className="result-toolbar">
                        <Tooltip
                          title={
                            "Clustering analysis in market analysis involves grouping survey responses based on shared characteristics or preferences, revealing distinct customer segments for targeted marketing strategies and product offerings. This method uncovers valuable insights for tailoring marketing efforts and enhancing customer satisfaction."
                          }
                        >
                          <i className="fa fa-info-circle icon-size"></i>
                        </Tooltip>
                        <a
                          className={
                            "fa fa-expand " + showButtonCR
                          }
                          onClick={(e) => chartenlarge("companyCR")}
                        ></a>
                        <a
                          className={
                            "fa fa-compress " + hideButtonCR
                          }
                          onClick={(e) => closeenlarge("companyCR")}
                        ></a>
                      </div>
                      <Box sx={{ height: chartBoxHeightCR, width: "100%" }}>
                        <div id="chart12c">
                          <Chart
                            height={chartHeightCR}
                            options={chartOptions2}
                            series={correspondenceAnalysis.chartSeries}
                            type="scatter"
                          />
                        </div>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid></> : null}
                {
                  resultData.template == "Market Research" &&
                  <>
                    <Grid item xs={4}>
                      <Card className="cardBox">
                        <CardContent>
                          <h3 className="float-left mr-2">
                            Radar Graph
                          </h3>
                          {/* <Tooltip title={" "}>
                            <i className="fa fa-info-circle icon-size"></i>
                          </Tooltip>
                           <a
                            className={
                              "fa fa-expand float-right mt-1 " + showButton
                            }
                            onClick={(e) => chartenlarge("companyC")}
                          ></a> */}
                          {/* <a
                            className={
                              "fa fa-compress float-right mt-1 " + hideButton
                            }
                            onClick={(e) => closeenlarge("companyC")}
                          ></a> */}

                          <Box sx={{ height: '250px', width: "100%" }}>
                            <div id="chart11">
                              <img src={NetPromoterScoreComingSoon} alt='convertml'  width={'100%'} height={230} />
                            </div>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={4}>
                      <Card className="cardBox">
                        <CardContent>
                          <h3 className="float-left mr-2">
                            Popularity Comparison
                          </h3>
                          {/* <Tooltip title={"This metric assesses the level of interest and value attributed to different topics that a potential customer is thinking of regarding your company."}>
                            <i className="fa fa-info-circle icon-size"></i>
                          </Tooltip>
                          <a
                            className={
                              "fa fa-expand float-right mt-1 " + showButton
                            }
                            onClick={(e) => chartenlarge("companyC")}
                          ></a> */}
                          {/* <a
                            className={
                              "fa fa-compress float-right mt-1 " + hideButton
                            }
                            onClick={(e) => closeenlarge("companyC")}
                          ></a> */}

                          <Box sx={{ height: '250px', width: "100%" }}>
                            <div id="chart11">
                              <img src={stackedBarChartsComingSoon} alt='convertml'  width={'100%'} height={230} />
                            </div>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={4}>
                      <Card className="cardBox">
                        <CardContent>
                          <h3 className="float-left mr-2">
                            Spending Range
                          </h3>
                          {/* <Tooltip title={"This metric assesses the level of interest and value attributed to different topics that a potential customer is thinking of regarding your company."}>
                            <i className="fa fa-info-circle icon-size"></i>
                          </Tooltip>
                          <a
                            className={
                              "fa fa-expand float-right mt-1 " + showButton
                            }
                            onClick={(e) => chartenlarge("companyC")}
                          ></a>   */}
                          {/* <a
                            className={
                              "fa fa-compress float-right mt-1 " + hideButton
                            }
                            onClick={(e) => closeenlarge("companyC")}
                          ></a> */}

                          <Box sx={{ height: '250px', width: "100%" }}>
                            <div id="chart11">
                              <img src={HistogramsComingSoon} alt='convertml'  width={'100%'} height={230} />
                            </div>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  </>
                }
              </Grid>
              <div className="clearfix"></div>
            </Box>
          </div>
          {positiveSatisfactionResult.filterdRow.length != 0 && dataTable && (
            <div>
              <Box
                sx={{
                  height: "calc(100vh - 18em)",
                  width: "99%",
                  background: "#ffffff",
                }}
              >
                {showLoder && (
                  <Box sx={{ textAlign: "center" }}>
                    <div style={{ paddingTop: 250 }}>
                      {" "}
                      <CircularProgress />
                    </div>
                  </Box>
                )}
                {!showLoder && (
                  <DataGridPro
                    className="table"
                    sx={{
                      height: "calc(100vh - 13.8em)",
                      width: "100%",
                      background: "#ffffff",
                    }}
                    rows={positiveSatisfactionResult.filterdRow}
                    columns={positiveSatisfactionResult.filterdCol}
                    pagination={true}
                    pageSizeOptions={[20, 50, 100]}
                    checkboxSelection={false}
                    disableSelectionOnClick
                    getRowHeight={() => "auto"}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 20,
                        },
                      },
                    }}
                   
                    hideFooterRowCount={true}
                    hideFooter={false}
                    editable
                  />
                )}
              </Box>
            </div>
          )}
        </SplitterLayout>
      </div>
    </div >
  );
}
